import React, { useState, useEffect, useRef } from "react";
import arrow from "../images/Stroke 1.svg";
import arrow2 from "../images/Stroke 2.svg";
import { IoMdArrowBack } from "react-icons/io";
import { IoRefreshSharp } from "react-icons/io5";
import { FiPause } from "react-icons/fi";
import { IoMdClose } from "react-icons/io";
import { IoShareSocialOutline } from "react-icons/io5";
import { Link } from "react-router-dom";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import Select from "react-select";
import ReactQuill from "react-quill";
import mail from "../images/mail.svg";
import rattingstar from "../images/ratting.svg";
import { IoIosArrowDown } from "react-icons/io";
import { IoIosArrowUp } from "react-icons/io";
import { CSVLink, CSVDownload } from "react-csv";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import { server_API } from "../config";
import union from "../images/union.svg";
import ReactStars from "react-stars";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useSelector } from "react-redux";
import { selectCid } from "../features/companyid";
import { selectUuid } from "../features/userid";
import { IoAlertCircleOutline } from "react-icons/io5";
import { MdOutlineDateRange } from "react-icons/md";
import { VscDebugRestart } from "react-icons/vsc";
import { LuRefreshCcw } from "react-icons/lu";
import DatePicker from "react-datepicker";
import { ToastIcon } from "./TestOfferInitiation";
import { getCurrencySymbol, getPhoneCode, formatSalary } from "../utils/currencyUtils";

const TempCandidates = () => {
  const [select, setSelect] = useState(0);
  const [link, setLink] = useState("");
  const [subtab, setSubTab] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const [isTwoOpen, setTwoOpen] = useState(true);
  const [activeId, setActiveId] = useState("");
  const [openPopup, setOpenPopup] = useState(false);
  const [recruiters, setRecruiters] = useState([]);
  const [hiringManagers, setHiringManagers] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [source, setSource] = useState("");
  const [openLink, setOpenLink] = useState("");
  const [salaryFitment, setSalaryFitment] = useState("");
  const [startingDate, setStartingDate] = useState();
  const [endingDate, setEndingDate] = useState();
  const [dateFocused, setDateFocused] = useState(false);
  const [timeToJoin, setTimeToJoin] = useState("");
  const [maxSalary, setMaxSalary] = useState(0);
  const [minSalary, setMinSalary] = useState(0);
  const [rounds, setRounds] = useState(new Map());
  const [selectedAll, setSelectedAll] = useState(false);
  const [selectedRows, setSelectdRows] = useState([]);
  const [open, setOpen] = useState(false);
  const [viewPdf, setViewPdf] = useState(false);
  const location = useLocation();
  const { id } = location.state;
  const [offered, setOffered] = useState([]);
  const [hired, setHired] = useState([]);
  const [onhold, setOnhold] = useState([]);
  const [reject, setReject] = useState([]);
  // const id = "1aff71a7-09e6-45c6-8957-f87d56030daf";
  const [applicants, setApplicants] = useState(null);
  const [sortedAll, setSortedAll] = useState([]);
  const [activeUuid, setActiveUuid] = useState("");
  const [popUpValue, setPopUpValue] = useState("");
  const [isData, setIsData] = useState(null);
  const [sortedInterview, setSortedInterview] = useState([]);
  const [sortedShortlisted, setSortedShortlisted] = useState([]);
  const [sendMail, setSendMail] = useState(false);
  const [roundsArray, setRoundsArray] = useState([]);
  const [csvData, setCsvData] = useState([]);
  const [rank, setRank] = useState(0);
  const [info, setInfo] = useState(false);
  const [jobDetails, setJobDetails] = useState({});
  const [status, setStatus] = useState("");
  const [index, setIndex] = useState(0);
  const [sortedApplicants, setSortedApplicants] = useState([]);
  const [pending, setPending] = useState([]);
  const [interviewed, setInterviewed] = useState([]);
  const [interviewDate, setInterviewDate] = useState("");
  const [im, setIm] = useState(null);
  const [doneFlag, setDoneFlag] = useState(false);
  const [technicalIm, setTechnicalIm] = useState(null);
  const [shortlisted, setShortlisted] = useState([]);
  const [voiceIm, setVoiceIm] = useState(null);
  const [aiIm, setAIIm] = useState(null);
  const [appData, setAppData] = useState({});
  const [technicalScore, setTechnicalScore] = useState(0);
  const [resScore, setResScore] = useState(0);
  const [aiScore, setAiScore] = useState(0);
  const [resComSorted, setResComSorted] = useState([]);
  const [vcScore, setVcScore] = useState(0);
  const [activeCandidate, setActiveCandidate] = useState({});
  const [sortby, setSortBy] = useState("");
  const [file, setFile] = useState(null);
  const [paginatedAll, setPaginatedAll] = useState([]);
  const navigate = useNavigate();
  const [readcsvData, setReadCsvData] = useState(null);
  // const companyId = localStorage.getItem('cid')
  const companyId = useSelector(selectCid);
  // const applicantId = localStorage.getItem('uuid')
  const applicantId = useSelector(selectUuid);
  const jobId = "60a61ed2-4eae-48fb-8e89-293dcfb5527e";
  const [templateData, setTemplateData] = useState([]);
  const [modalIsOpen, setmodalIsOpen] = useState("");
  const [multipleSelectModal, setMultipleSelectModal] = useState("");
  const [selectedModalIsOpen, setSelectedModalIsOpen] = useState("");
  const [star, setStar] = useState(0);
  const [oldratting, setOldratting] = useState([]);
  const [roundsNo, setRoundsNo] = useState(0);
  const [oldFeedback, setoldFeedback] = useState([]);
  const [feedback, setFeedback] = useState("");
  const [selectedHm, setSelectedHm] = useState([]);
  const hearoptions = [
    { value: "", label: "--" },
    { value: "Campus campaign", label: "Campus campaign" },
    { value: "Company website", label: "Company website" },
    { value: "Employees referral", label: "Employees referral" },
    { value: "Naukri", label: "Naukri" },
    { value: "Indeed", label: "Indeed" },
    { value: "LinkedIn", label: "LinkedIn" },
    { value: "Recruitment agency", label: "Recruitment agency" },
    { value: "Others", label: "Others" },
  ];

  const reasonOptions = [
    { value: "Not eligible", label: "Not eligible" },
    { value: "need Changes", label: "Need Changes" },
    { value: "Need Changes here too", label: "Nead Changes here too" },

    { value: "Others", label: "Others" },
  ];

  const perPageOptions = [
    { value: 10, label: "10" },
    { value: 25, label: "25" },
    { value: 50, label: "50" },
  ];
  const [itemsPerPage, setItemsPerPage] = useState(perPageOptions[0].value);
  const [companyCountryCode, setCompanyCountryCode] = useState("IN");
  // useEffect(()=>{
  //   if(selectPopupValue.length>0){

  //     if(selectPopupValue == "view"){
  //       setView(true);
  //       console.log(activeJob)
  //     }
  //     else if(selectPopupValue == "pause"){
  //       changeStatus(activeJob.uuid,"Paused")
  //     }
  //     else if(selectPopupValue == "close"){
  //       setOpenPopup(true)
  //       setActiveId(activeJob.uuid)
  //     }
  //     else if(selectPopupValue == "share"){
  //       setLink(activeJob.uuid)
  //       setOpenLink(true)
  //     }
  //     else if(selectPopupValue == "restart"){
  //       changeStatus(activeJob.uuid,"Open")
  //     }
  //     else if(selectPopupValue == "delete")
  //     {
  //      deleteJob(draftjobId);
  //     }
  //   }
  // },[selectPopupValue])

  const formatDate = (dateString) => {
    const date = new Date(dateString);

    const day = date.getDate();
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear().toString().slice(-2);

    return `${day} ${month} ${year}`;
  };

  const handleClick = (action) => {
    if (action === "pause") {
      changeStatus(id, "Paused");
      console.log("paused");
    } else if (action === "close") {
      setOpenPopup(true);
      setActiveId(id);
      console.log("paused");
    } else if (action === "share") {
      setLink(id);
      setOpenLink(true);
      console.log("paused");
    } else if (action == "restart") {
      changeStatus(id, "Open");
    }
  };
  const changeStatus = (id, status) => {
    axios
      .patch(`${server_API}/v2/job/update`, {
        uuid: id,
        companyid: companyId,
        jobstatus: status,
      })
      .then((response) => {
        console.log(response);
        if (status == "closed") {
          window.location.reload();
        } else {
          window.location.reload();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    setTimeToJoin("");
    setSalaryFitment("");
    setSource("");
  }, [select]);

  useEffect(() => {
    window.scrollTo(0, 0);

    axios
      .get(`${server_API}/v2/user/company/${companyId}`, {
        withCredentials: true,
      })
      .then((response) => {
        console.log("users info", response.data.message);
        setAllUsers(response.data.message.Users);
        console.log(allUsers);
        
        // Fetch company details for country code
         axios.get(`${server_API}/v2/company/get/${companyId}`)
         .then(res => {
             if (res.data.company_countries && res.data.company_countries.length > 0) {
                 setCompanyCountryCode(res.data.company_countries[0]);
             }
         })
         .catch(err => console.error(err));
      })
      .catch((err) => {
        setAllUsers([]);
        console.error(err);
      });
  }, [companyId]);

  useEffect(() => {
    if (allUsers.length > 0) {
      const users = allUsers.filter((item) => {
        if (item.status == "accepted") {
          Object.defineProperty(
            item,
            "value",
            Object.getOwnPropertyDescriptor(item, "uuid")
          );
          Object.defineProperty(
            item,
            "label",
            Object.getOwnPropertyDescriptor(item, "name")
          );
          return item;
        }
      });
      setHiringManagers(users);

      const editorOrViewers = allUsers.filter((f) => {
        if (f.privilege != "Admin" && f.status == "accepted") {
          Object.defineProperty(
            f,
            "value",
            Object.getOwnPropertyDescriptor(f, "uuid")
          );
          Object.defineProperty(
            f,
            "label",
            Object.getOwnPropertyDescriptor(f, "name")
          );
          return f;
        }
      });
      setRecruiters(editorOrViewers);
    }
  }, [allUsers]);
  useEffect(() => {
    if (applicants != null) {
      const pending = applicants.filter((f) => {
        if (f.status == "Pending") {
          return f;
        }
      });
      const interviewed = applicants.filter((f) => {
        if (f.status.includes("Interviewed")) {
          return f;
        }
      });
      const shotlisted = applicants.filter((f) => {
        if (f.status == "Shortlisted") {
          return f;
        }
      });
      const offered = applicants.filter((f) => {
        if (f.status == "Offered") {
          return f;
        }
      });
      const hire = applicants.filter((f) => {
        if (f.status == "Hired") {
          return f;
        }
      });
      const on_hold = applicants.filter((f) => {
        if (f.status == "Onhold") {
          return f;
        }
      });
      const reject = applicants.filter((f) => {
        if (f.status == "Rejected") {
          return f;
        }
      });

      let dat = applicants.map((a) => ({ ...a }));
      const data = dat.map((e) => {
        delete e.addedby;
        delete e.additionalinfo;
        delete e.applieddate;
        delete e.companyid;
        delete e.coverletter;
        delete e.currentJobtitle;
        delete e.currentcomany;
        delete e.currentsalary;
        delete e.educationaldetails;
        delete e.jobid;
        delete e.joiningtime;
        delete e.notes;
        delete e.noticeperiod;
        delete e.qualification;
        delete e.resume;
        delete e.resumeurl;
        delete e.skillset;
        delete e.totalexperience;
        delete e.updatedat;
        delete e.uuid;
        delete e.rating;
        delete e.whatsappreminder;
        delete e.countrycode;
        delete e.expectedsalary;
        delete e.address;
        return e;
      });

      setCsvData(data);
      setPending(pending);
      setInterviewed(interviewed);
      setShortlisted(shotlisted);
      setOffered(offered);
      setHired(hire);
      setOnhold(on_hold);
      setReject(reject);
    }
  }, [applicants]);

  useEffect(() => {
    if (interviewed.length > 0 && doneFlag == false) {
      interviewed.map((m) => {
        const st = m.status.split(" ");
        if (st.length == 1) {
          return;
        }
        const round_num = st[1];
        if (round_num.includes("R")) {
          const number = round_num[1];
          if (rounds.has(number)) {
            let temp = rounds.get(number);
            temp.push(m);
            rounds.set(number, temp);
          } else {
            rounds.set(number, [m]);
            setRoundsArray((prevValue) => [...prevValue, number]);
          }
        }
      });
      setDoneFlag(true);
    }
  }, [interviewed, doneFlag]);

  const headers = [
    { label: "Name", key: "name" },
    { label: "Technical Score", key: "technicalscore" },
    { label: "Email", key: "email" },
    { label: "Phone", key: "phone" },
    { label: "Interview Status", key: "status" },
    { label: "Resume Score", key: "resumescore" },
    { label: "Soft Skills Score", key: "aiscore" },
    { label: "Voice Analysis Score", key: "voiceanalysisscore" },
    { label: "Aggregate", key: "aggregate" },
    { label: "Applied on", key: "createdat" },
    { label: "First Reminder", key: "firstreminder" },
    { label: "Sent First Reminder", key: "sentfirstreminder" },
    { label: "Final Reminder", key: "finalreminder" },
    { label: "Sent Final Reminder", key: "sentfinalreminder" },
    { label: "Current Location", key: "current_location" },
    { label: "Preffered Location", key: "preferred_location" },
  ];

  const Tempheaders = [
    { label: "Name", key: "Name" },
    { label: "Mobile no", key: "Mobile no" },
    { label: "Email", key: "Email" },
  ];

  const TempData = [
    {
      Name: "John Doe",
      "Mobile no": "+1234567890",
      Email: "johndoe@gmail.com",
    },
    {
      Name: "Jane Smith",
      "Mobile no": "+1987654321",
      Email: "janesmith@gmail.com",
    },
    {
      Name: "Alice Johnson",
      "Mobile no": "+1122334455",
      Email: "alicejohnson@gmail.com",
    },
    // Add more data as needed
  ];

  const newRef = useRef(null);
  const shareRef = useRef(null);

  const handleOutsideClick = (e) => {
    if (newRef.current && !newRef.current.contains(e.target)) {
      setOpenPopup(false);
      window.location.reload();
    } else if (shareRef.current && !shareRef.current.contains(e.target)) {
      setOpenLink(false);
      window.location.reload();
    }
  };
  useEffect(() => {
    //console.log(sortby);
    if (applicants != null) {
      let sort_array = applicants.map((a) => ({ ...a }));
      if (sortby.length == 0) {
        sort_array = sort_array.sort((a, b) => b.aggregate - a.aggregate);
      }
      if (sortby == "res") {
        sort_array = sort_array.sort((a, b) => b.resumescore - a.resumescore);
      }
      if (sortby == "ai") {
        sort_array = sort_array.sort((a, b) => b.aiscore - a.aiscore);
      }
      if (sortby == "va") {
        sort_array = sort_array.sort(
          (a, b) => b.voiceanalysisscore - a.voiceanalysisscore
        );
      }
      if (sortby == "tech") {
        sort_array = sort_array.sort(
          (a, b) => b.technicalscore - a.technicalscore
        );
      }
      setSortedAll(sort_array);
      // //console.log(applicants);
    }
  }, [sortby, applicants]);

  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  useEffect(() => {
    if (interviewed.length > 0) {
      let sort_array = interviewed.map((a) => ({ ...a }));
      if (sortby.length == 0) {
        sort_array = sort_array.sort((a, b) => b.aggregate - a.aggregate);
      }
      if (sortby == "res") {
        sort_array = sort_array.sort((a, b) => b.resumescore - a.resumescore);
      }
      if (sortby == "ai") {
        sort_array = sort_array.sort((a, b) => b.aiscore - a.aiscore);
      }
      if (sortby == "va") {
        sort_array = sort_array.sort(
          (a, b) => b.voiceanalysisscore - a.voiceanalysisscore
        );
      }
      if (sortby == "tech") {
        sort_array = sort_array.sort(
          (a, b) => b.technicalscore - a.technicalscore
        );
      }
      setSortedInterview(sort_array);
    }
  }, [sortby, interviewed]);

  useEffect(() => {
    //console.log(sortby);
    if (shortlisted.length > 0) {
      let sort_array = shortlisted.map((a) => ({ ...a }));
      if (sortby.length == 0) {
        sort_array = sort_array.sort((a, b) => b.aggregate - a.aggregate);
      }
      if (sortby == "res") {
        sort_array = sort_array.sort((a, b) => b.resumescore - a.resumescore);
      }
      if (sortby == "ai") {
        sort_array = sort_array.sort((a, b) => b.aiscore - a.aiscore);
      }
      if (sortby == "va") {
        sort_array = sort_array.sort(
          (a, b) => b.voiceanalysisscore - a.voiceanalysisscore
        );
      }
      if (sortby == "tech") {
        sort_array = sort_array.sort(
          (a, b) => b.technicalscore - a.technicalscore
        );
      }
      setSortedShortlisted(sort_array);
    }
  }, [sortby, shortlisted]);

  //reduce spaci

  useEffect(() => {
    if (popUpValue.length > 0) {
      if (popUpValue == "change rounds") {
        switchRounds(status, activeUuid);
      }
      if (popUpValue == "select") {
        patchStatus(activeUuid, "Interviewed S");
      }
      if (popUpValue == "reject") {
        patchStatus(activeUuid, "Rejected");
      }
      if (popUpValue == "hold") {
        patchStatus(activeUuid, "Onhold");
      }
      if (popUpValue == "offer") {
        patchStatus(activeUuid, "Offered");
      }
    }
  }, [popUpValue]);

  const selectedOption = [
    { value: "offer", label: "Move to offer" },
    { value: "reject", label: "Reject" },
    { value: "hold", label: "On-hold" },
  ];
  const patchStatus = (id, status) => {
    axios
      .patch(`${server_API}/v2/applicant/update`, {
        companyid: companyId,
        uuid: id,
        status: status,
      })
      .then((res) => {
        window.location.reload();
        //console.log(res);
      })
      .catch((error) => {
        //console.log(error);
      });
  };

  const options = [
    { value: "change rounds", label: `Move to round ${subtab + 1}` },
    { value: "select", label: "Select" },
    { value: "reject", label: "Reject" },
    { value: "hold", label: "On-hold" },
  ];
  const onHoldOptions = [
    { value: "change rounds", label: `Move to round ${subtab + 1}` },
    { value: "select", label: "Select" },
    { value: "reject", label: "Reject" },
  ];
  const onRejectOptions = [
    { value: "change rounds", label: `Move to round ${subtab + 1}` },
    { value: "select", label: "Select" },

    { value: "hold", label: "On-hold" },
  ];
  const selectoptions = [{ value: "select", label: "Select" }];

  const pendingOptions = [
    { value: "summ", label: "Open Summary" },
    { value: "res", label: "Show Resume" },
  ];

  const unshortlistOptions = [
    { value: "summ", label: "Open Summary" },
    { value: "res", label: "Show Resume" },
    { value: "unshortlist", label: "Reject" },
  ];

  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastApplicant = currentPage * itemsPerPage;
  const indexOfFirstApplicant = indexOfLastApplicant - itemsPerPage;
  useEffect(() => {
    setPaginatedAll(
      sortedAll.slice(indexOfFirstApplicant, indexOfLastApplicant)
    );
  }, [sortedAll, currentPage, currentPage]);

  const totalAllPages = Math.ceil(sortedAll.length / itemsPerPage);

  console.log(sortedAll.length);
  console.log(indexOfLastApplicant);
  useEffect(() => {
    setSelectdRows([]);
  }, [subtab, select]);
  useEffect(() => {
    if (subtab > 0) {
      sessionStorage.setItem("tab", subtab);
    }
  }, [subtab]);

  useEffect(() => {
    window.scrollTo(0, 0);
    axios
      .get(`${server_API}/v2/job/get/${id}/${companyId}`)
      .then((res) => {
        //console.log(res);
        setJobDetails(res.data);
        //console.log(res.data.jobdescription);

        let maxSal = res.data.salaryto;
        let minSal = res.data.salaryfrom;
        maxSal = maxSal.replaceAll(",", "");
        minSal = minSal.replaceAll(",", "");
        setMaxSalary(parseInt(maxSal));
        setMinSalary(parseInt(minSal));
        axios
          .get(`${server_API}/v2/applicant/get/job/${id}/${companyId}`)
          .then((response) => {
            //console.log(response.data);
            setApplicants(response.data);
            setIsData(true);

            // //console.log(response.data)
          })
          .catch((error) => {
            setIsData(false);
            //console.error(error);
          });
      })
      .catch((err) => {
        //console.log(err);
      });
  }, []);

  const selectApplicant = () => {
    axios
      .patch(`${server_API}/v2/applicant/update`, {
        uuid: id,
        status: "Interviewed S",
      })
      .then((res) => {
        window.location.reload();
        //console.log(res);
      })
      .catch((error) => {
        //console.log(error);
      });
  };

  console.log("all candidate", paginatedAll);

  const switchRounds = (status, id) => {
    let stat = "";
    if (status == "Interviewed") {
      stat = "Interviewed R1";
    } else {
      const num = status.split(" ")[1];
      // //console.log(num)
      let numeric = parseInt(num[1]) + 1;
      stat = "Interviewed R" + numeric.toString();
    }
    axios
      .patch(`${server_API}/v2/applicant/update`, {
        uuid: id,
        companyid: companyId,
        status: stat,
        InterviewRating: oldratting,
        InterviewFeedback: oldFeedback,
      })
      .then((res) => {
        window.location.reload();
        //console.log(res);
      })
      .catch((error) => {
        //console.log(error);
      });
  };

  const handleCheckbox = () => {
    if (selectedAll) {
      setSelectdRows([]);
    } else {
      handleSelectedAll();
    }
    setSelectedAll(!selectedAll);
  };
  const handleSelectedRow = (id) => {
    console.log(id);
    if (selectedRows.includes(id)) {
      setSelectdRows(selectedRows.filter((rows) => rows !== id));
      console.log("selectedRows", selectedRows);
    } else {
      setSelectdRows([...selectedRows, id]);
      console.log("selectedRows", selectedRows);
    }
  };
  const handleSelectedAll = () => {
    //console.log(sortedInterview);
    const alluuid = sortedInterview.map((shortlist) => shortlist.uuid);
    setSelectdRows(alluuid);
    setSelectedAll(true);
    console.log("selectedRows", selectedRows);
  };

  const [currentInterviewedPage, setCurrentInterviewedPage] = useState(1);
  const indexOfLastInterviewedApplicant = currentInterviewedPage * itemsPerPage;
  const indexOfFirstInterviewedApplicant =
    indexOfLastInterviewedApplicant - itemsPerPage;

  useEffect(() => {
    if (select == 0) {
      setPaginatedAll(
        sortedAll.slice(
          indexOfFirstInterviewedApplicant,
          indexOfLastInterviewedApplicant
        )
      );
    } else if (select == 1) {
      if (subtab == 0) {
        setPaginatedAll(
          sortedInterview.slice(
            indexOfFirstInterviewedApplicant,
            indexOfLastInterviewedApplicant
          )
        );
      } else if (subtab > 0 && subtab < 99) {
        //console.log(subtab)
        const round_interview = rounds.get(subtab.toString());
        //console.log(round_interview)
        if (!round_interview) {
          setPaginatedAll([]);
        } else {
          setPaginatedAll(
            round_interview.slice(
              indexOfFirstInterviewedApplicant,
              indexOfLastInterviewedApplicant
            )
          );
        }
      } else if (subtab == 99) {
        const selected = sortedInterview.filter((s) => {
          if (s.status == "Interviewed S") {
            return s;
          }
        });
        setPaginatedAll(
          selected.slice(
            indexOfFirstInterviewedApplicant,
            indexOfLastInterviewedApplicant
          )
        );
      }
      //console.log(subtab)
    } else if (select == 2) {
      setPaginatedAll(
        offered.slice(
          indexOfFirstInterviewedApplicant,
          indexOfLastInterviewedApplicant
        )
      );
    } else if (select == 3) {
      setPaginatedAll(
        hired.slice(
          indexOfFirstInterviewedApplicant,
          indexOfLastInterviewedApplicant
        )
      );
    } else if (select == 4) {
      setPaginatedAll(
        onhold.slice(
          indexOfFirstInterviewedApplicant,
          indexOfLastInterviewedApplicant
        )
      );
    } else if (select == 5) {
      setPaginatedAll(
        reject.slice(
          indexOfFirstInterviewedApplicant,
          indexOfLastInterviewedApplicant
        )
      );
    }
  }, [select, sortedAll, subtab, itemsPerPage]);
  const totalInterviewedPages = Math.ceil(
    sortedInterview.length / itemsPerPage
  );

  const getInterviewedPageRange = () => {
    const totalPages = Math.ceil(totalInterviewedPages);
    const maxVisiblePages = 3;
    const middlePage = currentInterviewedPage;
    let startPage = middlePage - Math.floor(maxVisiblePages / 2);
    startPage = Math.max(startPage, 1);
    const endPage = Math.min(startPage + maxVisiblePages - 1, totalPages);
    return Array.from(
      { length: endPage - startPage + 1 },
      (_, i) => startPage + i
    );
  };

  const calculateAverageRating = (ratings) => {
    if (!Array.isArray(ratings) || ratings.length === 0) {
      return "0";
    }

    const sum = ratings.reduce(
      (accumulator, currentValue) => accumulator + currentValue,
      0
    );

    const averageRating = Math.round(sum / ratings.length);

    return averageRating;
  };

  useEffect(() => {
    if (roundsArray.length > 0) {
      console.log("rounds No", roundsNo);
      console.log(roundsArray[roundsArray.sort().length - 1]);
      let mx = Math.max(roundsNo, roundsArray[roundsArray.length - 1]);
      setRoundsNo(mx);

      // setRoundsNo((roundsNo > roundsArray[roundsArray.length - 1])? roundsNo: roundsArray[roundsArray.length - 1])
      console.log(mx);
      localStorage.setItem("roundsNo", roundsNo.toString());
    }
  }, [roundsArray]);

  useEffect(() => {
    if (localStorage.getItem("roundsNo") == null) {
      setRoundsNo(0);
    } else {
      setRoundsNo(localStorage.getItem("roundsNo"));
    }
  }, []);

  const handleRoundinfo = (id, roundFrom, roundto) => {
    const roundsinfo = {
      functionalmanagername: selectedHm.name,
      fmid: selectedHm.uuid,
      star: star,
      assigneetime: "2:00 PM",
      assigneedate: interviewDate,
      feedback: feedback,
      roundfrom: roundFrom.toString(),
      roundto: roundto.toString(),
    };
    axios
      .patch(`${server_API}/v2/applicant/update/roundinfo`, {
        applicantid: id,
        companyid: companyId,
        roundsinfo: roundsinfo,
      })
      .then((response) => {
        console.log(response);
        window.location.reload();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      {openLink && (
        <div className="fixed inset-0 bg-black bg-opacity-30 backdrop-blur-sm z-30 flex items-center justify-center">
          <div
            ref={shareRef}
            className="bg-white shadow-xl md:w-1/2 p-4 z-40 rounded-xl"
          >
            <div className="p-3 rounded-xl text-center flex flex-col space-y-4">
              <button
                onClick={() => {
                  setOpenLink(false);
                }}
                className="text-left"
              >
                <IoMdClose className="w-6 h-6" />
              </button>
              <p className="text-2xl font-semibold">Share link</p>
              <a
                className="text-blue-500 underline"
                href={`https://interviewguru.co/#/careers/${link}/${companyId}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                https://interviewguru.co/#/careers/{link}/{companyId}
              </a>
              <button
                className="bg-blue-500 text-white rounded-xl w-auto py-3"
                onClick={() => {
                  navigator.clipboard.writeText(
                    `https://interviewguru.co/#/careers/${link}/${companyId}`
                  );
                  setOpenLink(false);
                  toast.success("Link copied to clipboard", { icon: <ToastIcon /> });
                }}
              >
                Copy link
              </button>
            </div>
          </div>
        </div>
      )}
      {openPopup && (
        <div className="fixed inset-0 bg-black bg-opacity-30 backdrop-blur-sm z-30 flex items-center justify-center">
          <div ref={newRef} className="">
            <div className="fixed bg-white  shadow-xl md:w-1/2  p-4 z-40 rounded-xl left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
              <div className="p-3 rounded-xl text-center  ">
                <p className="font-semibold text-xl">
                  Are you sure you want to close this job?
                </p>
                <div className="flex w-full justify-around mt-5">
                  <button
                    className="text-red-500 border-red-500 border rounded-xl py-2 px-5 "
                    onClick={() => {
                      setOpenPopup(false);
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    className="bg-red-500 text-white border-red-500 border rounded-xl py-2 px-6 "
                    onClick={() => {
                      changeStatus(activeId, "Closed");
                      toast.success("The Job has been successfully closed", { icon: <ToastIcon /> });
                    }}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <div
        className={`p-6 bg-[#f0f4fc] ${modalIsOpen || selectedModalIsOpen ? "blur-2xl" : ""
          } min-h-screen flex flex-col `}
      >
        <div className="py-6 flex  flex-col justify-between bg-white rounded-xl shadow-lg">
          <div className="w-full flex justify-between">
            <div className="w-full flex items-start">
              <div className="px-4  border-l-4 h-full border-[#148EFF] justify-between items-center">
                <div className="flex">
                  <p className="text-lg font-semibold">
                    {jobDetails.profilename} - {jobDetails.department}
                  </p>
                </div>
                <p className=" text-base">
                  {jobDetails.companyjobcount} | {jobDetails.department} -{" "}
                  {jobDetails.jobtype} -{" "}
                  {jobDetails["location:"]?.replace(/,/g, ", ")} -{" "}
                  {jobDetails.experience}
                </p>
              </div>
              <div className="ml-4">
                <div className=" flex gap-3 ">
                  {jobDetails.jobstatus != "Paused" && (
                    <div
                      onClick={() => {
                        handleClick("pause");
                        toast.success("The Job has been successfully paused", { icon: <ToastIcon /> });
                      }}
                      className="bg-[#F1F4FB] p-1.5 rounded-md"
                    >
                      <FiPause className="text-slate-700 cursor-pointer w-4 h-4" />{" "}
                    </div>
                  )}
                  {jobDetails.jobstatus == "Paused" && (
                    <div
                      onClick={() => {
                        handleClick("restart");
                        toast.success(
                          "The Job has been successfully restarted"
                          , { icon: <ToastIcon /> });
                      }}
                      className="bg-[#F1F4FB] p-1.5 rounded-md"
                    >
                      <VscDebugRestart className="text-slate-700 cursor-pointer w-4 h-4" />{" "}
                    </div>
                  )}
                  <div
                    onClick={() => {
                      handleClick("close");
                    }}
                    className="bg-[#F1F4FB] p-1.5 rounded-md"
                  >
                    <IoMdClose className="text-slate-700 cursor-pointer w-4 h-4" />{" "}
                  </div>
                  <div
                    onClick={() => {
                      handleClick("share");
                    }}
                    className="bg-[#F1F4FB] p-1.5 rounded-md"
                  >
                    <IoShareSocialOutline className="text-slate-700 cursor-pointer w-4 h-4" />{" "}
                  </div>
                </div>
              </div>
            </div>
            <div className="flex space-x-3 items-center p-6">
              <button
                className=""
                onClick={() => {
                  setIsOpen(!isOpen);
                  if (setIsOpen) setTwoOpen(false);
                  else setTwoOpen(true);
                  setIsOpen(!isOpen);
                  setTwoOpen(isOpen);
                }}
              >
                <img
                  src={arrow}
                  alt=""
                  className={isOpen ? "rotate-180" : ""}
                />
              </button>
            </div>
          </div>
          {isOpen ? (
            <div className="mt-6">
              <div className="bg-white border-t-2 border-[#E9EBFA] p-6 ">
                <div className=" ">
                  <div className=" px-4 rounded-xl ">
                    <div className="flex flex-col space-y-4">
                      <div className="flex w-full ">
                        <p className="font-semibold w-1/2">
                          Job title:{" "}
                          <span className="text-[#8F94A1] font-normal">
                            {jobDetails.profilename}
                          </span>
                        </p>
                        <p className="font-semibold w-1/2">
                          Job type:{" "}
                          <span className="text-[#8F94A1] font-normal">
                            {jobDetails.jobtype}
                          </span>
                        </p>
                      </div>
                      <div className="flex w-full ">
                        <p className="font-semibold w-1/2">
                          No of positions:{" "}
                          <span className="text-[#8F94A1] font-normal">
                            {jobDetails.positionnumber}
                          </span>
                        </p>
                        <p className="font-semibold w-1/2">
                          Department:{" "}
                          <span className="text-[#8F94A1] font-normal">
                            {jobDetails.department}
                          </span>
                        </p>
                      </div>

                      <div className="flex w-full ">
                        <p className="font-semibold w-1/2">
                          Last date to apply:{" "}
                          <span className="text-[#8F94A1] font-normal">
                            {jobDetails?.applicationlastdate?.split("-")[2]}-
                            {jobDetails?.applicationlastdate?.split("-")[1]}-
                            {jobDetails?.applicationlastdate?.split("-")[0]}
                          </span>
                        </p>
                        <p className="font-semibold w-1/2">
                          Experience:{" "}
                          <span className="text-[#8F94A1] font-normal">
                            {jobDetails.experience}
                          </span>
                        </p>
                      </div>

                      <div className="flex w-full ">
                        <p className="font-semibold w-1/2">
                          Salary from:{" "}
                          <span className="text-[#8F94A1] font-normal">
                             {getCurrencySymbol(companyCountryCode)} {formatSalary(jobDetails.salaryfrom, companyCountryCode)}
                          </span>
                        </p>
                        <p className="font-semibold w-1/2">
                          Salary to:{" "}
                          <span className="text-[#8F94A1] font-normal">
                             {getCurrencySymbol(companyCountryCode)} {formatSalary(jobDetails.salaryto, companyCountryCode)}
                          </span>
                        </p>
                      </div>
                      <div className="flex w-full ">
                        <p className="font-semibold w-1/2">
                          Location:{" "}
                          <span className="text-[#8F94A1] font-normal">
                            {jobDetails["location:"]}
                          </span>
                        </p>
                        <p className="font-semibold w-1/2">
                          Work style:{" "}
                          <span className="text-[#8F94A1] font-normal">
                            {jobDetails.workstyle}
                          </span>
                        </p>
                      </div>

                      <div>
                        <p className="mb-2 font-semibold">Job description:</p>
                        <ReactQuill
                          value={jobDetails.jobdescription}
                          readOnly={true}
                          theme="bubble"
                        ></ReactQuill>
                        {/* <div className="text-[#8F94A1] " dangerouslySetInnerHTML={{__html: jobDetails.jobdescription}}></div> */}
                      </div>

                      <div>
                        <p className="mb-2 font-semibold">Skills weightage:</p>
                        <div className="flex space-x-5">
                          <p className="font-semibold w-1/2">
                            Resume compatibility score:{" "}
                            <span className="text-[#8F94A1] font-normal">
                              {jobDetails.resumecompatibility}
                            </span>
                          </p>
                          <p className="font-semibold w-1/2">
                            AI interview score:{" "}
                            <span className="text-[#8F94A1] font-normal">
                              {jobDetails.aiscore}
                            </span>
                          </p>
                          <p className="font-semibold w-1/2">
                            Voice analysis score:{" "}
                            <span className="text-[#8F94A1] font-normal">
                              {jobDetails.voiceanalysisscore}
                            </span>
                          </p>
                          {jobDetails.technicalweight > 0 && (
                            <p className="font-semibold w-1/2">
                              Technical score:{" "}
                              <span className="text-[#8F94A1] font-normal">
                                {jobDetails.technicalweight}
                              </span>
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            ""
          )}
        </div>

        <div className="flex flex-col justify-between bg-white rounded-xl shadow-lg">
          <div className="py-6 flex justify-between bg-white rounded-xl  ">
            <div className="px-4 border-l-4 border-[#148EFF] justify-between items-center">
              <p className="text-lg font-semibold">Overview</p>
            </div>

            <div className="flex space-x-3 items-center px-4">
              <button
                className=""
                onClick={() => {
                  setTwoOpen(!isTwoOpen);
                  setIsOpen(isTwoOpen);
                }}
              >
                <img
                  src={arrow}
                  alt=""
                  className={isTwoOpen ? "rotate-180" : ""}
                />
              </button>
            </div>
          </div>

          {isTwoOpen ? (
            <>
              {" "}
              <div className="border-[#E9EBFA] border"></div>
              <div className="card-body p-6 bg-white h-full flex flex-col  rounded-xl">
                <div className="flex justify-between mb-6">
                  <div className=" flex gap-[12px] items-center">
                    <Link to="/jobs">
                      <div className="tooltip">
                        <IoMdArrowBack className="text-lg text-[#444D63] w-6 h-6  tooltip"></IoMdArrowBack>
                        <p className="tooltiptext">Back</p>
                      </div>
                    </Link>
                    <div>
                      <button
                        onClick={() => {
                          window.location.reload();
                        }}
                        className="flex tooltip justify-center  items-center text-[#444D63]  rounded-xl"
                      >
                        <LuRefreshCcw className="text-lg text-[#444D63] w-5 h-5  tooltip"></LuRefreshCcw>
                        <p className="tooltiptext">Refresh</p>
                      </button>
                    </div>
                  </div>
                  <div className=" flex gap-2">
                    {csvData.length > 0 && (
                      <CSVLink
                        className="bg-[#0DCD94] text-white py-2 px-3  rounded-[4px]"
                        filename={`${jobDetails.profilename} candidates.csv`}
                        headers={headers}
                        data={csvData.map((row) => ({ ...row, agency_refferre_name: row.agency_name || row.refferre_name, heardaboutus: row.heardaboutus === "undefined" || !row.heardaboutus ? "Manually Added" : row.heardaboutus }))}
                      >
                        Export Data
                      </CSVLink>
                    )}
                    <button
                      onClick={() => {
                        setIsOpen(true);
                      }}
                      className="py-2 px-3 rounded-[4px] flex items-center bg-white text-[#148EFF] border-[#148EFF]  border-[1.4px]"
                    >
                      Invite Application
                      <span className="ml-2">
                        {" "}
                        {!open ? <IoIosArrowDown /> : <IoIosArrowUp />}
                      </span>
                    </button>
                    <div className="relative ">
                      <button
                        className={
                          !open
                            ? " h-full  bg-[#148EFF] text-white px-4 py-1 rounded-lg"
                            : " h-full  bg-[#148EFF] text-white px-4 py-1 rounded-t-lg"
                        }
                        onClick={() => {
                          setOpen(!open);
                        }}
                      >
                        <div className="flex items-center justify-between">
                          Add New Applicant
                          <span className="ml-2">
                            {" "}
                            {!open ? <IoIosArrowDown /> : <IoIosArrowUp />}
                          </span>
                        </div>
                      </button>

                      {open && (
                        <div className="flex flex-col bg-[#5AA7EF] absolute w-full text-white rounded-b-lg">
                          <button>
                            <div className="flex items-center space-x-4 py-3 px-3">
                              {/* <img src={pen} className="h-5"></img> */}
                              <p>Manually</p>
                            </div>
                          </button>

                          <button>
                            <div className="flex items-center space-x-4 py-3 px-3">
                              <p className="text-left">Bulk Upload</p>
                            </div>
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="p-[.625rem] bg-[#f0f4fc] rounded-xl mb-6  gap-4">
                  <div className="grid grid-cols-6 justify-items-center gap-4 font-semibold">
                    <div
                      className={
                        select == 0
                          ? " w-full px-2 py-3  bg-[#148EFF] text-white flex justify-center rounded-lg"
                          : " w-full px-2 py-3  flex justify-center rounded-lg"
                      }
                      onClick={() => {
                        setSelect(0);
                      }}
                    >
                      <button>All Application - {~sortedAll.length}</button>
                    </div>

                    <div
                      className={
                        select == 1
                          ? " w-full px-2 py-3 bg-[#148EFF] text-white flex justify-center rounded-lg"
                          : " w-full px-2 py-3  flex justify-center rounded-lg"
                      }
                      onClick={() => {
                        setSelect(1);
                      }}
                    >
                      <button>Interview - {~sortedInterview.length}</button>
                    </div>
                    <div
                      className={
                        select == 2
                          ? " w-full px-2 py-3 bg-[#148EFF] text-white flex justify-center rounded-lg"
                          : " w-full px-2 py-3  flex justify-center rounded-lg"
                      }
                      onClick={() => {
                        setSelect(2);
                      }}
                    >
                      <button>Offer - {~offered.length}</button>
                    </div>
                    <div
                      className={
                        select == 3
                          ? " w-full px-2 py-3 bg-[#148EFF] text-white flex justify-center rounded-lg"
                          : " w-full px-2 py-3  flex justify-center rounded-lg"
                      }
                      onClick={() => {
                        setSelect(3);
                      }}
                    >
                      <button>Hire - {~hired.length}</button>
                    </div>
                    <div
                      className={
                        select == 4
                          ? " w-full px-2 py-3 bg-[#148EFF] text-white flex justify-center rounded-lg"
                          : " w-full px-2 py-3  flex justify-center rounded-lg"
                      }
                      onClick={() => {
                        setSelect(4);
                      }}
                    >
                      <button>On-hold - {~onhold.length}</button>
                    </div>

                    <button
                      className={
                        select == 5
                          ? " w-full px-2 py-3 bg-[#148EFF] text-white flex justify-center rounded-lg"
                          : " w-full px-2 py-3  flex justify-center rounded-lg"
                      }
                      onClick={() => {
                        setSelect(5);
                      }}
                    >
                      Reject - {~reject.length}
                    </button>
                  </div>
                </div>
                {select != 1 && (
                  <>
                    {select == 0 ? (
                      <>
                        {" "}
                        <div className="flex items-center filter-container gap-[14px] mb-4">
                          <div className="w-[200px]">
                            <p className="font-semibold mb-1 text-sm">Source</p>

                            <Select
                              placeholder="Select Source"
                              className="text-[14px]"
                              onChange={(selectedOption) => {
                                setSource(selectedOption.value);
                              }}
                              options={hearoptions}
                            ></Select>
                          </div>

                          <div className="w-[200px]">
                            <p className="font-semibold mb-1 text-sm">
                              Salary Fitment
                            </p>

                            <Select
                              placeholder="Select Category"
                              className="text-[14px]"
                              onChange={() => {
                                setSalaryFitment(selectedOption.value);
                              }}
                              options={[
                                { value: "", label: "--" },
                                { value: "ar", label: "Above Range" },
                                { value: "br", label: "Below Range" },
                                { value: "wr", label: "Within Range" },
                              ]}
                            ></Select>
                          </div>

                          <div className="w-[200px]">
                            <p className="font-semibold text-sm mb-1">
                              Time To Join
                            </p>

                            <Select
                              placeholder="Select range"
                              className="text-[14px]"
                              onChange={(selectedOption) => {
                                setTimeToJoin(selectedOption.value);
                              }}
                              options={[
                                { value: "", label: "--" },
                                { value: "7", label: "<7 Days" },
                                { value: "14", label: "7 - 14 Days" },
                                { value: "30", label: "15 - 30 Days" },
                                { value: ">30", label: ">30 Days" },
                              ]}
                            ></Select>
                          </div>
                          <div className="w-[260px]">
                            <div className="text-sm  mb-1 font-semibold">
                              Application Date
                            </div>
                            <div className=" w-full ">
                              <div
                                className={` custom-placeholder flex items-center justify-center  rounded ${dateFocused
                                  ? " border-[#8f94a1] border-2"
                                  : "border-[#D2D4DA] border"
                                  }`}
                              >
                                {" "}
                                <span
                                  className={` ${dateFocused
                                    ? "bg-[#8f94a1]"
                                    : "bg-[#D2D4DA]"
                                    }  flex items-center rounded-l-sm w-fit h-9 px-2 `}
                                >
                                  <MdOutlineDateRange
                                    className={`${dateFocused
                                      ? "text-[#FFFFFF]"
                                      : " text-[#8f94a1]"
                                      } w-5  h-5`}
                                  />
                                </span>{" "}
                                <DatePicker
                                  selected={startingDate}
                                  onFocus={() => setDateFocused(true)}
                                  onBlur={() => setDateFocused(false)}
                                  onChange={(date) => setStartingDate(date)}
                                  selectsStart
                                  isClearable
                                  startDate={startingDate}
                                  endDate={endingDate}
                                  dateFormat="dd-MM-yyyy"
                                  className={` ${dateFocused
                                    ? "border-[#8f94a1]  border-r-2"
                                    : "border-[#D2D4DA] border-r"
                                    }  ${dateFocused || startingDate || endingDate
                                      ? "font-semibold"
                                      : ""
                                    }  w-full  text-[#8f94a1]  text-[14px]  z-50  h-9 px-2   `}
                                  placeholderText="From"
                                />
                                <DatePicker
                                  selected={endingDate}
                                  onFocus={() => setDateFocused(true)}
                                  onBlur={() => setDateFocused(false)}
                                  onChange={(date) => setEndingDate(date)}
                                  startDate={startingDate}
                                  isClearable
                                  endDate={endingDate}
                                  dateFormat="dd-MM-yyyy"
                                  selectsEnd
                                  className={` ${dateFocused
                                    ? "border-[#8f94a1]  "
                                    : "border-[#D2D4DA] "
                                    }  ${dateFocused || startingDate || endingDate
                                      ? "font-semibold"
                                      : ""
                                    }  w-full rounded-r  text-[#8f94a1]  text-[14px]  z-50  h-9 px-2   `}
                                  placeholderText="To"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    ) : (
                      <div className="flex  p-6 justify-between items-end pb-4">
                        <div className="flex  filter-container items-center gap-[14px]">
                          <div className="w-[200px]">
                            <p className="font-semibold mb-1 text-sm">Source</p>

                            <Select
                              placeholder="Select Source"
                              className="text-[14px]"
                              onChange={(selectedOption) => {
                                setSource(selectedOption.value);
                              }}
                              options={hearoptions}
                            ></Select>
                          </div>

                          <div className="w-[200px]">
                            <p className="font-semibold mb-1 text-sm">
                              Salary Fitment
                            </p>

                            <Select
                              placeholder="Select Category"
                              className="text-[14px]"
                              onChange={() => {
                                setSalaryFitment(selectedOption.value);
                              }}
                              options={[
                                { value: "", label: "--" },
                                { value: "ar", label: "Above Range" },
                                { value: "br", label: "Below Range" },
                                { value: "wr", label: "Within Range" },
                              ]}
                            ></Select>
                          </div>

                          <div className="w-[200px]">
                            <p className="font-semibold text-sm mb-1">
                              Time to join
                            </p>

                            <Select
                              placeholder="Select range"
                              className="text-[14px]"
                              onChange={(selectedOption) => {
                                setTimeToJoin(selectedOption.value);
                              }}
                              options={[
                                { value: "", label: "--" },
                                { value: "7", label: "<7 Days" },
                                { value: "14", label: "7 - 14 Days" },
                                { value: "30", label: "15 - 30 Days" },
                                { value: ">30", label: ">30 Days" },
                              ]}
                            ></Select>
                          </div>
                          <div className="w-[260px]">
                            <div className="text-sm  mb-1 font-semibold">
                              Application Date
                            </div>
                            <div className=" w-full ">
                              <div
                                className={` custom-placeholder flex items-center justify-center  rounded ${dateFocused
                                  ? " border-[#8f94a1] border-2"
                                  : "border-[#D2D4DA] border"
                                  }`}
                              >
                                {" "}
                                <span
                                  className={` ${dateFocused
                                    ? "bg-[#8f94a1]"
                                    : "bg-[#D2D4DA]"
                                    }  flex items-center rounded-l-sm w-fit h-9 px-2 `}
                                >
                                  <MdOutlineDateRange
                                    className={`${dateFocused
                                      ? "text-[#FFFFFF]"
                                      : " text-[#8f94a1]"
                                      } w-5  h-5`}
                                  />
                                </span>{" "}
                                <DatePicker
                                  selected={startingDate}
                                  onFocus={() => setDateFocused(true)}
                                  onBlur={() => setDateFocused(false)}
                                  onChange={(date) => setStartingDate(date)}
                                  selectsStart
                                  isClearable
                                  startDate={startingDate}
                                  endDate={endingDate}
                                  dateFormat="dd-MM-yyyy"
                                  className={` ${dateFocused
                                    ? "border-[#8f94a1]  border-r-2"
                                    : "border-[#D2D4DA] border-r"
                                    }  ${dateFocused || startingDate || endingDate
                                      ? "font-semibold"
                                      : ""
                                    }  w-full  text-[#8f94a1]  text-[14px]  z-50  h-9 px-2   `}
                                  placeholderText="From"
                                />
                                <DatePicker
                                  selected={endingDate}
                                  onFocus={() => setDateFocused(true)}
                                  onBlur={() => setDateFocused(false)}
                                  onChange={(date) => setEndingDate(date)}
                                  startDate={startingDate}
                                  isClearable
                                  endDate={endingDate}
                                  dateFormat="dd-MM-yyyy"
                                  selectsEnd
                                  className={` ${dateFocused
                                    ? "border-[#8f94a1]  "
                                    : "border-[#D2D4DA] "
                                    }  ${dateFocused || startingDate || endingDate
                                      ? "font-semibold"
                                      : ""
                                    }  w-full rounded-r  text-[#8f94a1]  text-[14px]  z-50  h-9 px-2   `}
                                  placeholderText="To"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        {selectedRows.length >= 1 && (
                          <div
                            id="selectAll"
                            className="text-left w-[120px] text-[12px]"
                          >
                            <Select
                              options={options}
                              placeholder="Select Action"
                              onChange={(option) => {
                                setMultipleSelectModal(option.value);
                                console.log("selectall", multipleSelectModal);
                              }}
                            ></Select>
                          </div>
                        )}
                      </div>
                    )}
                  </>
                )}

                {select == 0 && (
                  <>
                    <div>
                      <Table>
                        <Thead className="top-0  text-center text-sm">
                          <Tr>
                            <Th className="border-y  px-4 py-[20px]">Rank</Th>
                            <Th className="border-y text-left  px-[20px] py-4 ">
                              Applicant Name
                            </Th>

                            <Th className="border-y px-4 py-[23px] ">
                              Applied On
                            </Th>

                            <Th className="border-y px-4 py-[23px] ">
                              <button
                                className="h-full w-full items-center flex  justify-center"
                                onClick={() => {
                                  setSortBy("");
                                }}
                              >
                                Aggregate AI Score
                                {sortby == "" && (
                                  <img src={union} className="w-3 h-3 ml-2" />
                                )}
                              </button>
                            </Th>
                            <Th className="border-y px-4 py-[23px] ">
                              Average Rating
                            </Th>
                            <Th className="border-y px-4 py-[23px] ">
                              Current Status
                            </Th>
                            <Th className="border-y px-4 py-[23px] ">
                              Salary Fitment
                            </Th>

                            <Th className="border-y px-4 py-[23px] ">
                              Actions
                            </Th>
                          </Tr>
                        </Thead>
                        <Tbody>
                          {paginatedAll.map((e, i) => {
                            return (
                              <Tr className="text-sm">
                                <Td
                                  className={
                                    "border-y  text-center px-4 py-[23px] "
                                  }
                                >
                                  <div>{i + 1}</div>
                                </Td>
                                <Td className="border-y px-[20px] py-4 text-left  text-[#148EFF]">
                                  {/* <button className="text-blue-500">
                                  {e.name}
                                </button> */}
                                  <div className="">
                                    <p className="flex items-center ">
                                      <button
                                        className="text-left"
                                        onClick={() => {
                                          navigate("/jobs/candidates/about", {
                                            state: {
                                              uuid: e.uuid,
                                              rank:
                                                indexOfFirstApplicant + i + 1,
                                            },
                                          });
                                          // sessionStorage.setItem('currentPage', currentPage)
                                        }}
                                      >
                                        {e.name}
                                      </button>
                                      <div className="group relative">
                                        <img
                                          src={mail}
                                          className="h-4 mx-1"
                                        ></img>
                                        <div className="absolute transition-all left-3 top-3 text-left px-[10px] py-[7px] z-20 border-2  border-light-blue scale-0 rounded-lg bg-white w-fit shadow-md text-[9px]  group-hover:scale-100">
                                          <a
                                            href={`mailto:${e.email}`}
                                            className="truncate"
                                          >
                                            {e.email}
                                          </a>
                                        </div>
                                      </div>
                                    </p>
                                    <p className="text-black text-[10px] mt-[2px]">
                                      {e.countrycode} {e.phone}
                                    </p>
                                  </div>
                                </Td>

                                <Td className="border-y px-4 py-[23px] text-center">
                                  {(() => {
                                    const date = new Date(e.createdat);

                                    const year = date.getFullYear();
                                    const month = String(
                                      date.getMonth() + 1
                                    ).padStart(2, "0");
                                    const day = String(date.getDate()).padStart(
                                      2,
                                      "0"
                                    );
                                    const formattedDate = `${day}-${month}-${year}`;

                                    return formattedDate;
                                  })()}
                                </Td>

                                <Td className="border-y px-4 py-[23px] text-center">
                                  {e.aiscore == 0 ? "-" : `${e.aiscore}`}
                                </Td>
                                <Td className="border-y text-[14px]  px-4 py-[23px] text-center">
                                  <div className="flex justify-center">
                                    {e.interviewrating == null ? (
                                      "-"
                                    ) : (
                                      <div className="bg-[#FFEBD6]  text-[#FE7F00] flex justify-center items-center align-center rounded !py-[2px]  px-[10px] gap-[6px] ">
                                        <p className=" text-sm">
                                          {calculateAverageRating(
                                            e.interviewrating
                                          )}
                                        </p>
                                        <img
                                          className="w-[10px] h-[10px]"
                                          src={rattingstar}
                                        />
                                      </div>
                                    )}
                                  </div>
                                </Td>
                                <Td
                                  className={`border-y text-center px-4 py-[23px] ${e.status === "Pending"
                                    ? "text-[#444D63]"
                                    : e.status === "Interviewed"
                                      ? "text-[#FE9933]"
                                      : e.status === "Interviewed S"
                                        ? "text-[#40B2B7E5]"
                                        : e.status === "Rejected"
                                          ? "text-[#E95060]"
                                          : e.status === "Onhold"
                                            ? "text-[#444D63]"
                                            : e.status?.includes("Interviewed R")
                                              ? "text-[#FE9933]"
                                              : ""
                                    }`}
                                // style={{
                                //   color:
                                //     e.status?.includes('R') || e.status === 'Onhold' ? '#FE9933' :
                                //     e.status?.includes('S') ? '#40B2B7E5' :
                                //     e.status === 'Rejected' ? '#E95060' :
                                //     'inherit'
                                // }}
                                >
                                  {e.status}
                                </Td>
                                <Td className="text-center border-y px-4 py-[23px] relative">
                                  <div className="group  flex justify-center">
                                    <button>
                                      {parseInt(
                                        e?.expectedsalary
                                          ?.split(" ")[1]
                                          ?.replaceAll(",", "")
                                      ) < minSalary && (
                                          <div className="text-[#8F94A1]">
                                            <p className="text-[0.6rem]">
                                              Below Range
                                            </p>
                                            <div className="bg-[#E9EBFA] h-[0.5rem] relative my-1 rounded-lg w-[3.9rem] mx-auto">
                                              <div
                                                className={`absolute bg-[#8F94A1] h-[0.5rem] rounded-lg`}
                                                style={{ width: `33%` }}
                                              ></div>
                                            </div>
                                          </div>
                                        )}
                                      {parseInt(
                                        e?.expectedsalary
                                          ?.split(" ")[1]
                                          ?.replaceAll(",", "")
                                      ) >= minSalary &&
                                        parseInt(
                                          e?.expectedsalary
                                            ?.split(" ")[1]
                                            ?.replaceAll(",", "")
                                        ) <= maxSalary && (
                                          <div className="text-[#40B2B7]">
                                            <p className="text-[0.7rem]">
                                              Within Range
                                            </p>
                                            <div className="bg-[#E9EBFA] h-[0.5rem] relative my-1 rounded-lg w-[3.9rem] mx-auto">
                                              <div
                                                className={`absolute bg-[#40B2B7] h-[0.5rem] rounded-lg`}
                                                style={{ width: `50%` }}
                                              ></div>
                                            </div>
                                          </div>
                                        )}
                                      {parseInt(
                                        e?.expectedsalary
                                          ?.split(" ")[1]
                                          ?.replaceAll(",", "")
                                      ) > maxSalary && (
                                          <div className="text-[#E95060]">
                                            <p className="text-[0.7rem]">
                                              Above Range
                                            </p>
                                            <div className="bg-[#E9EBFA] h-[0.5rem] relative my-1 rounded-lg w-[3.9rem] mx-auto">
                                              <div
                                                className={`absolute bg-[#E95060] h-[0.5rem] rounded-lg`}
                                                style={{ width: `66%` }}
                                              ></div>
                                            </div>
                                          </div>
                                        )}
                                      {!e.expectedsalary && <p>-</p>}
                                    </button>
                                    {parseInt(
                                      e?.expectedsalary
                                        ?.split(" ")[1]
                                        ?.replaceAll(",", "")
                                    ) < minSalary && (
                                        <div
                                          textv
                                          className="absolute transition-all left-11 top-16   px-[10px] py-[7px] text-left shadow-md z-20 border-2 whitespace-nowrap border-[#8F94A1]  scale-0 rounded-lg bg-white  text-[9px]  group-hover:scale-100"
                                        >
                                          <p className="mb-1 gap-[4px] flex">
                                            <b>Current Salary: </b>
                                            <span>{e.currentsalary}</span>
                                          </p>
                                          <p className="flex gap-[4px]">
                                            <b>Expected Salary: </b>
                                            <span>{e.expectedsalary}</span>
                                          </p>
                                        </div>
                                      )}
                                    {parseInt(
                                      e?.expectedsalary
                                        ?.split(" ")[1]
                                        ?.replaceAll(",", "")
                                    ) > minSalary &&
                                      parseInt(
                                        e?.expectedsalary
                                          ?.split(" ")[1]
                                          ?.replaceAll(",", "")
                                      ) < maxSalary && (
                                        <div
                                          textv
                                          className="absolute transition-all left-11 top-16   px-[10px] py-[7px] text-left shadow-md z-20 border-2 whitespace-nowrap border-[#40B2B7]  scale-0 rounded-lg bg-white  text-[9px]  group-hover:scale-100"
                                        >
                                          <p className="mb-1 gap-[4px] flex">
                                            <b>Current Salary: </b>
                                            <span>{e.currentsalary}</span>
                                          </p>
                                          <p className="flex gap-[4px]">
                                            <b>Expected Salary: </b>
                                            <span>{e.expectedsalary}</span>
                                          </p>
                                        </div>
                                      )}
                                    {parseInt(
                                      e?.expectedsalary
                                        ?.split(" ")[1]
                                        ?.replaceAll(",", "")
                                    ) > maxSalary && (
                                        <div
                                          textv
                                          className="absolute transition-all left-11 top-16   px-[10px] py-[7px] text-left shadow-md z-20 border-2 whitespace-nowrap border-[#E95060]  scale-0 rounded-lg bg-white  text-[9px]  group-hover:scale-100"
                                        >
                                          <p className="mb-1 gap-[4px] flex">
                                            <b>Current Salary: </b>
                                            <span>{e.currentsalary}</span>
                                          </p>
                                          <p className="flex gap-[4px]">
                                            <b>Expected Salary: </b>
                                            <span>{e.expectedsalary}</span>
                                          </p>
                                        </div>
                                      )}
                                  </div>
                                </Td>

                                <Td className="border-y px-4 py-[23px] text-left w-[170px] text-[12px]">
                                  {e.status != "Shortlisted" ? (
                                    <Select
                                      options={options}
                                      placeholder="Select Action"
                                    ></Select>
                                  ) : (
                                    <Select
                                      options={unshortlistOptions}
                                      placeholder="Select Action"
                                    ></Select>
                                  )}
                                </Td>
                              </Tr>
                            );
                          })}
                        </Tbody>
                      </Table>
                    </div>
                    <nav className="bg-white mt-4  flex items-center justify-between ">
                      <div className="hidden sm:block">
                        <div className="flex items-center text-[14px] font-normal z-10 gap-2">
                          Show
                          <Select
                            placeholder={itemsPerPage}
                            options={perPageOptions}
                            className="z-20 text-[14px] page-select  "
                            onChange={(selectedOption) => {
                              setItemsPerPage(selectedOption.value);
                              console.log("ItemsPer page", itemsPerPage);
                            }}
                            menuPlacement="top"
                          />
                          entries
                        </div>
                      </div>
                      <div className="flex-1 flex justify-between sm:justify-end ">
                        <button
                          onClick={() =>
                            setCurrentInterviewedPage(
                              currentInterviewedPage - 1
                            )
                          }
                          disabled={currentInterviewedPage === 1}
                          className={`relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-l-md text-gray-700 bg-white hover:text-gray-500 ${currentInterviewedPage === 1
                            ? "opacity-50"
                            : "hover:bg-gray-50"
                            }`}
                        >
                          Previous
                        </button>
                        <div className="flex ">
                          {getInterviewedPageRange().map((page) => (
                            <button
                              key={page}
                              onClick={() => setCurrentInterviewedPage(page)}
                              className={`relative inline-flex items-center px-4 py-2 border-y border-r border-gray-300 text-sm font-medium  text-gray-700   cursor-pointer ${currentInterviewedPage === page
                                ? "bg-light-blue text-white"
                                : ""
                                }`}
                            >
                              {page}
                            </button>
                          ))}
                        </div>
                        <button
                          onClick={() =>
                            setCurrentInterviewedPage(
                              currentInterviewedPage + 1
                            )
                          }
                          disabled={
                            currentInterviewedPage === totalInterviewedPages
                          }
                          className={`relative inline-flex items-center px-4 py-2 border-y border-r border-gray-300 text-sm font-medium rounded-r-md text-gray-700 bg-white hover:text-gray-500 ${currentInterviewedPage === totalInterviewedPages
                            ? "opacity-50"
                            : "hover:bg-gray-50"
                            }`}
                        >
                          Next
                        </button>
                      </div>
                    </nav>
                  </>
                )}
                {select == 1 && (
                  <>
                    <div className=" flex flex-col  border-[#F1F4FB] border-2 rounded-xl">
                      <div>
                        <div className="pt-2 bg-[#f0f4fc] rounded-t-lg">
                          <div className="grid grid-cols-6 justify-items-center ">
                            <div
                              className={
                                subtab == 0
                                  ? " w-full px-2 py-3 font-semibold bg-white  flex justify-center rounded-t-xl"
                                  : " w-full px-2 py-3  flex justify-center rounded-lg"
                              }
                              onClick={() => {
                                setSubTab(0);
                              }}
                            >
                              <button
                                className={subtab == 0 ? "" : "text-[#8F94A1] "}
                              >
                                AI Interview{" "}
                                <span
                                  className={
                                    subtab == 0
                                      ? "text-white text-sm font-semibold bg-[#148EFF] rounded-full px-2 py-1"
                                      : " text-white text-sm bg-[#8F94A1] rounded-full px-2 py-1"
                                  }
                                >
                                  {sortedInterview.length}
                                </span>
                              </button>
                            </div>

                            {roundsArray.sort().map((values) => {
                              return (
                                <div
                                  className={
                                    subtab == parseInt(values)
                                      ? " w-full px-2 py-3 font-semibold bg-white flex justify-center rounded-t-xl"
                                      : " w-full px-2 py-3  flex justify-center rounded-lg"
                                  }
                                  onClick={() => {
                                    setSubTab(parseInt(values));
                                  }}
                                >
                                  <button
                                    className={
                                      subtab == parseInt(values)
                                        ? ""
                                        : "text-[#8F94A1]"
                                    }
                                  >
                                    Round {values}{" "}
                                    <span
                                      className={
                                        subtab == parseInt(values)
                                          ? "text-white text-sm font-semibold bg-[#148EFF] rounded-full px-2 py-1"
                                          : " text-white text-sm bg-[#8F94A1] rounded-full px-2 py-1"
                                      }
                                    >
                                      {
                                        rounds
                                          .get(values.toString())
                                          .slice(
                                            indexOfFirstInterviewedApplicant,
                                            indexOfLastInterviewedApplicant
                                          ).length
                                      }
                                    </span>
                                  </button>
                                </div>
                              );
                            })}
                            <div
                              className={
                                subtab == 99
                                  ? " w-full font-semibold px-2 py-3 bg-white flex justify-center rounded-t-xl"
                                  : " w-full px-2 py-3  flex justify-center rounded-lg"
                              }
                              onClick={() => {
                                setSubTab(99);
                              }}
                            >
                              <button
                                className={subtab == 99 ? "" : "text-[#8F94A1]"}
                              >
                                Selected{" "}
                                <span
                                  className={
                                    subtab == 99
                                      ? "text-white font-semibold text-sm bg-[#148EFF] rounded-full px-2 py-1"
                                      : " text-white text-sm bg-[#8F94A1] rounded-full px-2 py-1"
                                  }
                                >
                                  {
                                    sortedInterview.filter(
                                      (s) => s.status === "Interviewed S"
                                    ).length
                                  }
                                </span>
                              </button>
                            </div>
                          </div>
                        </div>

                        <div className="flex  p-6 justify-between items-end pb-4">
                          <div className="flex  filter-container items-center gap-[14px]">
                            <div className="w-[200px]">
                              <p className="font-semibold mb-1 text-sm">
                                Source
                              </p>

                              <Select
                                placeholder="Select Source"
                                className="text-[14px]"
                                onChange={(selectedOption) => {
                                  setSource(selectedOption.value);
                                }}
                                options={hearoptions}
                              ></Select>
                            </div>

                            <div className="w-[200px]">
                              <p className="font-semibold mb-1 text-sm">
                                Salary Fitment
                              </p>

                              <Select
                                placeholder="Select Category"
                                className="text-[14px]"
                                onChange={() => {
                                  setSalaryFitment(selectedOption.value);
                                }}
                                options={[
                                  { value: "", label: "--" },
                                  { value: "ar", label: "Above Range" },
                                  { value: "br", label: "Below Range" },
                                  { value: "wr", label: "Within Range" },
                                ]}
                              ></Select>
                            </div>

                            <div className="w-[200px]">
                              <p className="font-semibold text-sm mb-1">
                                Time to join
                              </p>

                              <Select
                                placeholder="Select range"
                                className="text-[14px]"
                                onChange={(selectedOption) => {
                                  setTimeToJoin(selectedOption.value);
                                }}
                                options={[
                                  { value: "", label: "--" },
                                  { value: "7", label: "<7 Days" },
                                  { value: "14", label: "7 - 14 Days" },
                                  { value: "30", label: "15 - 30 Days" },
                                  { value: ">30", label: ">30 Days" },
                                ]}
                              ></Select>
                            </div>
                            <div className="w-[260px]">
                              <div className="text-sm  mb-1 font-semibold">
                                Application Date
                              </div>
                              <div className=" w-full ">
                                <div
                                  className={` custom-placeholder flex items-center justify-center  rounded ${dateFocused
                                    ? " border-[#8f94a1] border-2"
                                    : "border-[#D2D4DA] border"
                                    }`}
                                >
                                  {" "}
                                  <span
                                    className={` ${dateFocused
                                      ? "bg-[#8f94a1]"
                                      : "bg-[#D2D4DA]"
                                      }  flex items-center rounded-l-sm w-fit h-9 px-2 `}
                                  >
                                    <MdOutlineDateRange
                                      className={`${dateFocused
                                        ? "text-[#FFFFFF]"
                                        : " text-[#8f94a1]"
                                        } w-5  h-5`}
                                    />
                                  </span>{" "}
                                  <DatePicker
                                    selected={startingDate}
                                    onFocus={() => setDateFocused(true)}
                                    onBlur={() => setDateFocused(false)}
                                    onChange={(date) => setStartingDate(date)}
                                    selectsStart
                                    isClearable
                                    startDate={startingDate}
                                    endDate={endingDate}
                                    dateFormat="dd-MM-yyyy"
                                    className={` ${dateFocused
                                      ? "border-[#8f94a1]  border-r-2"
                                      : "border-[#D2D4DA] border-r"
                                      }  ${dateFocused || startingDate || endingDate
                                        ? "font-semibold"
                                        : ""
                                      }  w-full  text-[#8f94a1]  text-[14px]  z-50  h-9 px-2   `}
                                    placeholderText="From"
                                  />
                                  <DatePicker
                                    selected={endingDate}
                                    onFocus={() => setDateFocused(true)}
                                    onBlur={() => setDateFocused(false)}
                                    onChange={(date) => setEndingDate(date)}
                                    startDate={startingDate}
                                    isClearable
                                    endDate={endingDate}
                                    dateFormat="dd-MM-yyyy"
                                    selectsEnd
                                    className={` ${dateFocused
                                      ? "border-[#8f94a1]  "
                                      : "border-[#D2D4DA] "
                                      }  ${dateFocused || startingDate || endingDate
                                        ? "font-semibold"
                                        : ""
                                      }  w-full rounded-r  text-[#8f94a1]  text-[14px]  z-50  h-9 px-2   `}
                                    placeholderText="To"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          {selectedRows.length >= 1 && (
                            <div
                              id="selectAll"
                              className="text-left w-[120px] text-[12px]"
                            >
                              <Select
                                options={options}
                                placeholder="Select Action"
                                onChange={(option) => {
                                  setMultipleSelectModal(option.value);
                                  console.log("selectall", multipleSelectModal);
                                }}
                              ></Select>
                            </div>
                          )}
                        </div>
                      </div>

                      {subtab == 0 && (
                        <div className="px-6 pb-6 rounded-b-lg">
                          <div>
                            <Table>
                              <Thead className="top-0  text-center text-sm">
                                <Tr>
                                  <Th className="border-y  py-[23px] px-4">
                                    <input
                                      type="checkbox"
                                      className="w-4 h-4"
                                      checked={selectedAll}
                                      onChange={() => {
                                        handleCheckbox();
                                      }}
                                    />
                                  </Th>
                                  <Th className="border-y  px-4  py-[20px]">
                                    Rank
                                  </Th>
                                  <Th className="border-y text-left  px-[20px] py-4 w-[200px]  ">
                                    Applicant Name
                                  </Th>
                                  <Th className="border-y px-4  ">
                                    <button className="h-full w-full flex items-center justify-center ">
                                      Resume Score
                                    </button>
                                  </Th>
                                  <Th className="border-y px-4  ">
                                    <button className="h-full w-full flex items-center  justify-center">
                                      AI Interview Score
                                    </button>
                                  </Th>

                                  <Th className="border-y px-4  ">
                                    <button className="h-full w-full flex items-center  justify-center">
                                      Technical Score
                                    </button>
                                  </Th>

                                  <Th className="border-y px-4 py-[23px] ">
                                    <button className="h-full w-full flex items-center  justify-center">
                                      Voice Analysis Score
                                    </button>
                                  </Th>
                                  <Th className="border-y px-4 py-[23px] ">
                                    <button className="h-full w-full items-center flex  justify-center">
                                      Aggregate AI Score
                                    </button>
                                  </Th>
                                  <Th className="border-y px-4  ">
                                    Salary Fitment
                                  </Th>
                                  <Th className="border-y px-4  ">Actions</Th>
                                </Tr>
                              </Thead>
                              <Tbody>
                                {paginatedAll.map((e, i) => {
                                  return (
                                    <Tr className="text-sm">
                                      <Td
                                        className={
                                          "border-y  text-center px-4 py-[23px] "
                                        }
                                      >
                                        <span>
                                          <input
                                            type="checkbox"
                                            className="w-4 h-4"
                                            checked={
                                              selectedRows.includes(e.uuid)
                                                ? true
                                                : false
                                            }
                                            onChange={() =>
                                              handleSelectedRow(e.uuid)
                                            }
                                          />
                                        </span>
                                      </Td>
                                      <Td
                                        className={
                                          "border-y  text-center px-4 py-[23px] "
                                        }
                                      >
                                        <div>{i + 1}</div>
                                      </Td>
                                      <Td className="border-y px-[20px] py-4  text-[#148EFF]">
                                        <div className="">
                                          <p className="flex items-center ">
                                            <button
                                              className="text-left"
                                              onClick={() => {
                                                navigate(
                                                  "/jobs/candidates/about",
                                                  {
                                                    state: {
                                                      uuid: e.uuid,
                                                      rank:
                                                        indexOfFirstApplicant +
                                                        i +
                                                        1,
                                                    },
                                                  }
                                                );
                                                // sessionStorage.setItem('currentPage', currentPage)
                                              }}
                                            >
                                              {e.name}
                                            </button>
                                            <div className="group relative">
                                              <img
                                                src={mail}
                                                className="h-4 mx-1"
                                              ></img>
                                              <div className="absolute transition-all left-3 top-3 text-left px-[10px] py-[7px] z-20 border-2  border-light-blue scale-0 rounded-lg bg-white w-fit shadow-md text-[9px]  group-hover:scale-100">
                                                <a
                                                  href={`mailto:${e.email}`}
                                                  className="truncate"
                                                >
                                                  {e.email}
                                                </a>
                                              </div>
                                            </div>
                                          </p>
                                          <p className="text-black text-[10px] mt-[2px]">
                                            {e.countrycode} {e.phone}
                                          </p>
                                        </div>
                                      </Td>

                                      <Td className="border-y px-4 py-[23px] text-center">
                                        {e.resumescore}
                                      </Td>
                                      <Td className="border-y px-4 py-[23px] text-center">
                                        {e.aiscore == 0 ? "-" : `${e.aiscore}`}
                                      </Td>

                                      <Td className="border-y px-4 py-[23px] text-center">
                                        {e.technicalscore == 0
                                          ? "-"
                                          : `${e.technicalscore}`}
                                      </Td>

                                      <Td className="border-y px-4 py-[23px] text-center">
                                        {e.voiceanalysisscore == 0
                                          ? "-"
                                          : `${e.voiceanalysisscore}`}
                                      </Td>
                                      <Td className="border-y text-center px-4 py-[23px] ">
                                        {e.aggregate == 0
                                          ? "-"
                                          : `${e.aggregate}`}
                                      </Td>

                                      <Td className="text-center border-y px-4 py-[23px] relative">
                                        <div className="group  flex justify-center">
                                          <button>
                                            {parseInt(
                                              e?.expectedsalary
                                                ?.split(" ")[1]
                                                ?.replaceAll(",", "")
                                            ) < minSalary && (
                                                <div className="text-[#8F94A1]">
                                                  <p className="text-[0.6rem]">
                                                    Below Range
                                                  </p>
                                                  <div className="bg-[#E9EBFA] h-[0.5rem] relative my-1 rounded-lg w-[3.9rem] mx-auto">
                                                    <div
                                                      className={`absolute bg-[#8F94A1] h-[0.5rem] rounded-lg`}
                                                      style={{ width: `33%` }}
                                                    ></div>
                                                  </div>
                                                </div>
                                              )}
                                            {parseInt(
                                              e?.expectedsalary
                                                ?.split(" ")[1]
                                                ?.replaceAll(",", "")
                                            ) >= minSalary &&
                                              parseInt(
                                                e?.expectedsalary
                                                  ?.split(" ")[1]
                                                  ?.replaceAll(",", "")
                                              ) <= maxSalary && (
                                                <div className="text-[#40B2B7]">
                                                  <p className="text-[0.7rem]">
                                                    Within Range
                                                  </p>
                                                  <div className="bg-[#E9EBFA] h-[0.5rem] relative my-1 rounded-lg w-[3.9rem] mx-auto">
                                                    <div
                                                      className={`absolute bg-[#40B2B7] h-[0.5rem] rounded-lg`}
                                                      style={{ width: `50%` }}
                                                    ></div>
                                                  </div>
                                                </div>
                                              )}
                                            {parseInt(
                                              e?.expectedsalary
                                                ?.split(" ")[1]
                                                ?.replaceAll(",", "")
                                            ) > maxSalary && (
                                                <div className="text-[#E95060]">
                                                  <p className="text-[0.7rem]">
                                                    Above Range
                                                  </p>
                                                  <div className="bg-[#E9EBFA] h-[0.5rem] relative my-1 rounded-lg w-[3.9rem] mx-auto">
                                                    <div
                                                      className={`absolute bg-[#E95060] h-[0.5rem] rounded-lg`}
                                                      style={{ width: `66%` }}
                                                    ></div>
                                                  </div>
                                                </div>
                                              )}
                                            {!e.expectedsalary && <p>-</p>}
                                          </button>
                                          {parseInt(
                                            e?.expectedsalary
                                              ?.split(" ")[1]
                                              ?.replaceAll(",", "")
                                          ) < minSalary && (
                                              <div
                                                textv
                                                className="absolute transition-all left-11 top-16   px-[10px] py-[7px] text-left shadow-md z-20 border-2 whitespace-nowrap border-[#8F94A1]  scale-0 rounded-lg bg-white  text-[9px]  group-hover:scale-100"
                                              >
                                                <p className="mb-1 gap-[4px] flex">
                                                  <b>Current Salary: </b>
                                                  <span>{e.currentsalary}</span>
                                                </p>
                                                <p className="flex gap-[4px]">
                                                  <b>Expected Salary: </b>
                                                  <span>{e.expectedsalary}</span>
                                                </p>
                                              </div>
                                            )}
                                          {parseInt(
                                            e?.expectedsalary
                                              ?.split(" ")[1]
                                              ?.replaceAll(",", "")
                                          ) > minSalary &&
                                            parseInt(
                                              e?.expectedsalary
                                                ?.split(" ")[1]
                                                ?.replaceAll(",", "")
                                            ) < maxSalary && (
                                              <div
                                                textv
                                                className="absolute transition-all left-11 top-16   px-[10px] py-[7px] text-left shadow-md z-20 border-2 whitespace-nowrap border-[#40B2B7]  scale-0 rounded-lg bg-white  text-[9px]  group-hover:scale-100"
                                              >
                                                <p className="mb-1 gap-[4px] flex">
                                                  <b>Current Salary: </b>
                                                  <span>{e.currentsalary}</span>
                                                </p>
                                                <p className="flex gap-[4px]">
                                                  <b>Expected Salary: </b>
                                                  <span>
                                                    {e.expectedsalary}
                                                  </span>
                                                </p>
                                              </div>
                                            )}
                                          {parseInt(
                                            e?.expectedsalary
                                              ?.split(" ")[1]
                                              ?.replaceAll(",", "")
                                          ) > maxSalary && (
                                              <div
                                                textv
                                                className="absolute transition-all left-11 top-16   px-[10px] py-[7px] text-left shadow-md z-20 border-2 whitespace-nowrap border-[#E95060]  scale-0 rounded-lg bg-white  text-[9px]  group-hover:scale-100"
                                              >
                                                <p className="mb-1 gap-[4px] flex">
                                                  <b>Current Salary: </b>
                                                  <span>{e.currentsalary}</span>
                                                </p>
                                                <p className="flex gap-[4px]">
                                                  <b>Expected Salary: </b>
                                                  <span>{e.expectedsalary}</span>
                                                </p>
                                              </div>
                                            )}
                                        </div>
                                      </Td>
                                      <Td className="border-y px-4 py-[23px] text-left w-[170px] text-[12px]">
                                        {e.status?.includes("S") ? (
                                          <Select
                                            options={selectedOption}
                                            placeholder="Select Action"
                                          ></Select>
                                        ) : (
                                          <Select
                                            value={popUpValue}
                                            onChange={(option) => {
                                              setStatus(e.status);
                                              setActiveUuid(e.uuid);
                                              setmodalIsOpen(option.value);
                                              setOldratting(
                                                e.interviewrating == null
                                                  ? []
                                                  : e.interviewrating
                                              );
                                              setoldFeedback(
                                                e.interviewfeedback == null
                                                  ? []
                                                  : e.interviewfeedback
                                              );
                                            }}
                                            options={options}
                                            placeholder="Select Action"
                                          ></Select>
                                        )}
                                      </Td>
                                    </Tr>
                                  );
                                })}
                              </Tbody>
                            </Table>
                          </div>
                          <nav className="bg-white mt-4  flex items-center justify-between">
                            <div className="hidden sm:block">
                              <div className="flex items-center text-[14px] font-normal z-10 gap-2">
                                Show
                                <Select
                                  placeholder={itemsPerPage}
                                  options={perPageOptions}
                                  className="z-20 text-[14px] page-select  "
                                  onChange={(selectedOption) => {
                                    setItemsPerPage(selectedOption.value);
                                  }}
                                  menuPlacement="top"
                                />
                                entries
                              </div>
                            </div>
                            <div className="flex-1 flex justify-between sm:justify-end ">
                              <button
                                onClick={() =>
                                  setCurrentInterviewedPage(
                                    currentInterviewedPage - 1
                                  )
                                }
                                disabled={currentInterviewedPage === 1}
                                className={`relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-l-md text-gray-700 bg-white hover:text-gray-500 ${currentInterviewedPage === 1
                                  ? "opacity-50"
                                  : "hover:bg-gray-50"
                                  }`}
                              >
                                Previous
                              </button>
                              <div className="flex ">
                                {getInterviewedPageRange().map((page) => (
                                  <button
                                    key={page}
                                    onClick={() =>
                                      setCurrentInterviewedPage(page)
                                    }
                                    className={`relative inline-flex items-center px-4 py-2 border-y border-r border-gray-300 text-sm font-medium  text-gray-700   cursor-pointer ${currentInterviewedPage === page
                                      ? "bg-light-blue text-white"
                                      : ""
                                      }`}
                                  >
                                    {page}
                                  </button>
                                ))}
                              </div>
                              <button
                                onClick={() =>
                                  setCurrentInterviewedPage(
                                    currentInterviewedPage + 1
                                  )
                                }
                                disabled={
                                  currentInterviewedPage ===
                                  totalInterviewedPages
                                }
                                className={`relative inline-flex items-center px-4 py-2 border-y border-r border-gray-300 text-sm font-medium rounded-r-md text-gray-700 bg-white hover:text-gray-500 ${currentInterviewedPage ===
                                  totalInterviewedPages
                                  ? "opacity-50"
                                  : "hover:bg-gray-50"
                                  }`}
                              >
                                Next
                              </button>
                            </div>
                          </nav>
                        </div>
                      )}
                      {/* {subtab == 1 &&( <div className="p-6">
                      <div>
                        <Table>
                          <Thead className="top-0  text-center text-sm">
                            <Tr>
                              <Th className="border-y px-4 py-[23px] ">Rank</Th>
                              <Th className="border-y px-4 py-[23px] ">Applicant Name</Th>
                              <Th className="border-y px-4 py-[23px] ">Email</Th>
                              <Th className="border-y px-4 py-[23px] ">phone</Th>
                              <Th className="border-y px-4 py-[23px] ">
                                <button className="h-full w-full items-center flex text-blue-500 justify-center">
                                  Aggregate Score
                                </button>
                              </Th>
                              <Th className="border-y px-4 py-[23px] ">Interview Date</Th>
                              <Th className="border-y px-4 py-[23px] ">Interviewer</Th>
                              <Th className="border-y px-4 py-[23px] ">Actions</Th>
                            </Tr>
                          </Thead>
                          <Tbody>
                            {paginatedAll.map((e, i) => {
                              return (
                                <Tr className="text-sm">
                                  <Td className={"border  text-center px-4 py-[23px] "}>
                                    <div>{i + 1}</div>
                                  </Td>
                                  <Td className="border-y px-4 py-[23px] ">
                                    <button className="text-blue-500">
                                      {e.name}
                                    </button>
                                  </Td>
                                  <Td className="border-y px-4 py-[23px] ">
                                    <div className="flex flex-col space-y-1 text-center">
                                      <p>
                                        <a
                                          href={`mailto:${e.email}`}
                                          className="text-blue-500"
                                        >
                                          {e.email}
                                        </a>
                                      </p>
                                    </div>
                                  </Td>
                                  <Td className="border-y px-4 py-[23px] text-center">
                                    {e.phone}
                                  </Td>
                                  <Td className="border-y text-center px-4 py-[23px] ">
                                    {e.aggregate == 0 ? "-" : `${e.aggregate}`}
                                  </Td>
                                  <Td className="border-y text-center px-4 py-[23px] ">
                                    { e.interviewdate}
                                  </Td>
                                  <Td className="border-y px-4 py-[23px] ">{e.Interviewer}</Td>

                                  <Td className="border-y px-4 py-[23px] "> 
                                    <Select 
                                    value={popUpValue}
                                    onChange={(option)=>{
                                      setStatus(e.status)
                                      setPopUpValue(option.value);
                                      setActiveUuid(e.uuid)
                                    }}
                                    options={options}></Select>
                                  </Td>
                                </Tr>
                              );
                            })}
                          </Tbody>
                        </Table>
                      </div>
                      <nav className="bg-white mt-4  flex items-center justify-between">
                        <div className="hidden sm:block">
                          {sortedInterview.length !== 0 ? (
                            <p className="text-sm text-gray-700">
                              {indexOfFirstInterviewedApplicant + 1} to{" "}
                              {currentInterviewedPage !== totalInterviewedPages
                                ? indexOfLastInterviewedApplicant
                                : sortedInterview.length}{" "}
                              of {sortedInterview.length} applicant
                            </p>
                          ) : (
                            <p className="text-sm text-gray-700">
                              {0} to {0} of {sortedInterview.length} applicant
                            </p>
                          )}
                        </div>
                        <div className="flex-1 flex justify-between sm:justify-end gap-1">
                          <button
                            onClick={() =>
                              setCurrentInterviewedPage(
                                currentInterviewedPage - 1
                              )
                            }
                            disabled={currentInterviewedPage === 1}
                            className={`relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:text-gray-500 ${
                              currentInterviewedPage === 1
                                ? "opacity-50"
                                : "hover:bg-gray-50"
                            }`}
                          >
                            Previous
                          </button>
                          <div className="flex space-x-2">
                            {getInterviewedPageRange().map((page) => (
                              <button
                                key={page}
                                onClick={() => setCurrentInterviewedPage(page)}
                                className={`relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:text-gray-500 cursor-pointer ${
                                  currentInterviewedPage === page
                                    ? "bg-gray-100"
                                    : "hover:bg-gray-50"
                                }`}
                              >
                                {page}
                              </button>
                            ))}
                          </div>
                          <button
                            onClick={() =>
                              setCurrentInterviewedPage(
                                currentInterviewedPage + 1
                              )
                            }
                            disabled={
                              currentInterviewedPage === totalInterviewedPages
                            }
                            className={`relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:text-gray-500 ${
                              currentInterviewedPage === totalInterviewedPages
                                ? "opacity-50"
                                : "hover:bg-gray-50"
                            }`}
                          >
                            Next
                          </button>
                        </div>
                      </nav>
                    </div>)} */}

                      {roundsArray.sort().map((r) => {
                        return (
                          <>
                            {subtab == r && (
                              <div className="p-6 pt-0">
                                <div>
                                  <Table>
                                    <Thead className="top-0  text-center text-sm">
                                      <Tr>
                                        <Th className="border-y  py-[23px] px-4">
                                          <input
                                            type="checkbox"
                                            checked={selectedAll}
                                            className="w-4 h-4"
                                            onChange={() => {
                                              handleCheckbox();
                                            }}
                                          />
                                        </Th>
                                        <Th className="border-y px-4 w-28   py-[20px]">
                                          AI Interview Rank
                                        </Th>
                                        <Th className="border-y px-[20px] py-4 text-left ">
                                          Applicant Name
                                        </Th>
                                        <Th className="border-y px-4 py-[23px] ">
                                          Aggregate AI Score
                                        </Th>

                                        <Th className="border-y px-4 py-[23px] ">
                                          Interview Date
                                        </Th>
                                        <Th className="border-y px-4 py-[23px] ">
                                          Interviewer
                                        </Th>
                                        {r >= 3 && (
                                          <Th className="border-y px-4 py-[23px] ">
                                            {subtab >= 4
                                              ? "Average Rating"
                                              : `Round ${r - 1} Rating`}
                                          </Th>
                                        )}
                                        <Th className="border-y px-4 py-[23px] ">
                                          Salary Fitment
                                        </Th>
                                        <Th className="border-y px-4 py-[23px] ">
                                          Actions
                                        </Th>
                                      </Tr>
                                    </Thead>
                                    <Tbody>
                                      {paginatedAll.map((e, i) => {
                                        //console.log(e.interviewrating.length)
                                        return (
                                          <Tr className="text-sm">
                                            <Td
                                              className={
                                                "border-y  text-center py-[23px] px-4 "
                                              }
                                            >
                                              <span>
                                                <input
                                                  type="checkbox"
                                                  className="w-4 h-4"
                                                  checked={
                                                    selectedRows.includes(
                                                      e.uuid
                                                    )
                                                      ? true
                                                      : false
                                                  }
                                                  onChange={() =>
                                                    handleSelectedRow(e.uuid)
                                                  }
                                                />
                                              </span>
                                            </Td>
                                            <Td
                                              className={
                                                "border-y  text-center px-4 py-6"
                                              }
                                            >
                                              <div>{i + 1}</div>
                                            </Td>
                                            <Td className="border-y px-[20px] py-4   text-[#148EFF]">
                                              <div className="">
                                                <p className="flex items-center ">
                                                  <button
                                                    className="text-left"
                                                    onClick={() => {
                                                      navigate(
                                                        "/jobs/candidates/about",
                                                        {
                                                          state: {
                                                            uuid: e.uuid,
                                                            rank:
                                                              indexOfFirstApplicant +
                                                              i +
                                                              1,
                                                          },
                                                        }
                                                      );
                                                      // sessionStorage.setItem('currentPage', currentPage)
                                                    }}
                                                  >
                                                    {e.name}
                                                  </button>
                                                  <div className="group relative">
                                                    <img
                                                      src={mail}
                                                      className="h-4 mx-1"
                                                    ></img>
                                                    <div className="absolute transition-all left-3 top-3 text-left px-[10px] py-[7px] z-20 border-2  border-light-blue scale-0 rounded-lg bg-white w-fit shadow-md text-[9px]  group-hover:scale-100">
                                                      <a
                                                        href={`mailto:${e.email}`}
                                                        className="truncate"
                                                      >
                                                        {e.email}
                                                      </a>
                                                    </div>
                                                  </div>
                                                </p>
                                                <p className="text-black text-[10px] mt-[2px]">
                                                  {e.countrycode} {e.phone}
                                                </p>
                                              </div>
                                            </Td>

                                            <Td className="border-y text-center px-4 py-[23px] ">
                                              {e.aggregate == 0
                                                ? "-"
                                                : `${e.aggregate}`}
                                            </Td>
                                            <Td className="border-y text-center px-4 py-[23px] ">
                                              {formatDate(e.interviewdate)}
                                            </Td>
                                            <Td className="border-y px-4 py-[23px] ">
                                              {e.Interviewer}
                                            </Td>
                                            {r >= 3 && (
                                              <Td className="border-y px-4 py-[23px] text-center  font-semibold  ">
                                                {e.interviewrating != null ? (
                                                  e.interviewrating.length <=
                                                    3 ? (
                                                    <div className="flex justify-center align-center gap-2">
                                                      {e?.interviewrating[0]}
                                                      <img
                                                        src={rattingstar}
                                                        alt="rating"
                                                      />
                                                    </div>
                                                  ) : (
                                                    <div className="flex justify-center">
                                                      <div className="bg-[#FFEBD6] text-[#FE7F00] flex justify-center items-center align-center rounded p-[.1rem] px-3 gap-2">
                                                        <p className="">
                                                          {calculateAverageRating(
                                                            e.interviewrating
                                                          )}
                                                        </p>
                                                        <img
                                                          className="w-3 h-3"
                                                          src={rattingstar}
                                                        />
                                                      </div>
                                                    </div>
                                                  )
                                                ) : (
                                                  "0"
                                                )}
                                              </Td>
                                            )}
                                            <Td className="text-center border-y px-4 py-[23px] relative">
                                              <div className="group  flex justify-center">
                                                <button>
                                                  {parseInt(
                                                    e?.expectedsalary
                                                      ?.split(" ")[1]
                                                      ?.replaceAll(",", "")
                                                  ) < minSalary && (
                                                      <div className="text-[#8F94A1]">
                                                        <p className="text-[0.6rem]">
                                                          Below Range
                                                        </p>
                                                        <div className="bg-[#E9EBFA] h-[0.5rem] relative my-1 rounded-lg w-[3.9rem] mx-auto">
                                                          <div
                                                            className={`absolute bg-[#8F94A1] h-[0.5rem] rounded-lg`}
                                                            style={{
                                                              width: `33%`,
                                                            }}
                                                          ></div>
                                                        </div>
                                                      </div>
                                                    )}
                                                  {parseInt(
                                                    e?.expectedsalary
                                                      ?.split(" ")[1]
                                                      ?.replaceAll(",", "")
                                                  ) >= minSalary &&
                                                    parseInt(
                                                      e?.expectedsalary
                                                        ?.split(" ")[1]
                                                        ?.replaceAll(",", "")
                                                    ) <= maxSalary && (
                                                      <div className="text-[#40B2B7]">
                                                        <p className="text-[0.7rem]">
                                                          Within Range
                                                        </p>
                                                        <div className="bg-[#E9EBFA] h-[0.5rem] relative my-1 rounded-lg w-[3.9rem] mx-auto">
                                                          <div
                                                            className={`absolute bg-[#40B2B7] h-[0.5rem] rounded-lg`}
                                                            style={{
                                                              width: `50%`,
                                                            }}
                                                          ></div>
                                                        </div>
                                                      </div>
                                                    )}
                                                  {parseInt(
                                                    e?.expectedsalary
                                                      ?.split(" ")[1]
                                                      ?.replaceAll(",", "")
                                                  ) > maxSalary && (
                                                      <div className="text-[#E95060]">
                                                        <p className="text-[0.7rem]">
                                                          Above Range
                                                        </p>
                                                        <div className="bg-[#E9EBFA] h-[0.5rem] relative my-1 rounded-lg w-[3.9rem] mx-auto">
                                                          <div
                                                            className={`absolute bg-[#E95060] h-[0.5rem] rounded-lg`}
                                                            style={{
                                                              width: `66%`,
                                                            }}
                                                          ></div>
                                                        </div>
                                                      </div>
                                                    )}
                                                  {!e.expectedsalary && (
                                                    <p>-</p>
                                                  )}
                                                </button>
                                                {parseInt(
                                                  e?.expectedsalary
                                                    ?.split(" ")[1]
                                                    ?.replaceAll(",", "")
                                                ) < minSalary && (
                                                    <div
                                                      textv
                                                      className="absolute transition-all left-11 top-16   px-[10px] py-[7px] text-left shadow-md z-20 border-2 whitespace-nowrap border-[#8F94A1]  scale-0 rounded-lg bg-white  text-[9px]  group-hover:scale-100"
                                                    >
                                                      <p className="mb-1 gap-[4px] flex">
                                                        <b>Current Salary: </b>
                                                        <span>
                                                          {e.currentsalary}
                                                        </span>
                                                      </p>
                                                      <p className="flex gap-[4px]">
                                                        <b>Expected Salary: </b>
                                                        <span>
                                                          {e.expectedsalary}
                                                        </span>
                                                      </p>
                                                    </div>
                                                  )}
                                                {parseInt(
                                                  e?.expectedsalary
                                                    ?.split(" ")[1]
                                                    ?.replaceAll(",", "")
                                                ) > minSalary &&
                                                  parseInt(
                                                    e?.expectedsalary
                                                      ?.split(" ")[1]
                                                      ?.replaceAll(",", "")
                                                  ) < maxSalary && (
                                                    <div
                                                      textv
                                                      className="absolute transition-all left-11 top-16   px-[10px] py-[7px] text-left shadow-md z-20 border-2 whitespace-nowrap border-[#40B2B7]  scale-0 rounded-lg bg-white  text-[9px]  group-hover:scale-100"
                                                    >
                                                      <p className="mb-1 gap-[4px] flex">
                                                        <b>Current Salary: </b>
                                                        <span>
                                                          {e.currentsalary}
                                                        </span>
                                                      </p>
                                                      <p className="flex gap-[4px]">
                                                        <b>Expected Salary: </b>
                                                        <span>
                                                          {e.expectedsalary}
                                                        </span>
                                                      </p>
                                                    </div>
                                                  )}
                                                {parseInt(
                                                  e?.expectedsalary
                                                    ?.split(" ")[1]
                                                    ?.replaceAll(",", "")
                                                ) > maxSalary && (
                                                    <div
                                                      textv
                                                      className="absolute transition-all left-11 top-16   px-[10px] py-[7px] text-left shadow-md z-20 border-2 whitespace-nowrap border-[#E95060]  scale-0 rounded-lg bg-white  text-[9px]  group-hover:scale-100"
                                                    >
                                                      <p className="mb-1 gap-[4px] flex">
                                                        <b>Current Salary: </b>
                                                        <span>
                                                          {e.currentsalary}
                                                        </span>
                                                      </p>
                                                      <p className="flex gap-[4px]">
                                                        <b>Expected Salary: </b>
                                                        <span>
                                                          {e.expectedsalary}
                                                        </span>
                                                      </p>
                                                    </div>
                                                  )}
                                              </div>
                                            </Td>
                                            <Td className="border-y px-4 py-[23px] text-left w-[170px] text-[12px]">
                                              <Select
                                                value={popUpValue}
                                                onChange={(option) => {
                                                  setmodalIsOpen(option.value);
                                                  setStatus(e.status);
                                                  setActiveUuid(e.uuid);
                                                  //console.log(e.interviewrating)
                                                  setOldratting(
                                                    e.interviewrating == null
                                                      ? []
                                                      : e.interviewrating
                                                  );
                                                  setoldFeedback(
                                                    e.interviewfeedback == null
                                                      ? []
                                                      : e.interviewfeedback
                                                  );
                                                }}
                                                options={options}
                                                placeholder="Select Action"
                                              ></Select>
                                            </Td>
                                          </Tr>
                                        );
                                      })}
                                    </Tbody>
                                  </Table>
                                </div>
                                <nav className="bg-white mt-4  flex items-center justify-between">
                                  <div className="hidden sm:block">
                                    <div className="flex items-center text-[14px] font-normal z-10 gap-2">
                                      Show
                                      <Select
                                        placeholder={itemsPerPage}
                                        options={perPageOptions}
                                        className="z-20 text-[14px] page-select  "
                                        onChange={(selectedOption) => {
                                          setItemsPerPage(selectedOption.value);
                                        }}
                                        menuPlacement="top"
                                      />
                                      entries
                                    </div>
                                  </div>
                                  <div className="flex-1 flex justify-between sm:justify-end ">
                                    <button
                                      onClick={() =>
                                        setCurrentInterviewedPage(
                                          currentInterviewedPage - 1
                                        )
                                      }
                                      disabled={currentInterviewedPage === 1}
                                      className={`relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-l-md text-gray-700 bg-white hover:text-gray-500 ${currentInterviewedPage === 1
                                        ? "opacity-50"
                                        : "hover:bg-gray-50"
                                        }`}
                                    >
                                      Previous
                                    </button>
                                    <div className="flex ">
                                      {getInterviewedPageRange().map((page) => (
                                        <button
                                          key={page}
                                          onClick={() =>
                                            setCurrentInterviewedPage(page)
                                          }
                                          className={`relative inline-flex items-center px-4 py-2 border-y border-r border-gray-300 text-sm font-medium  text-gray-700   cursor-pointer ${currentInterviewedPage === page
                                            ? "bg-light-blue text-white"
                                            : ""
                                            }`}
                                        >
                                          {page}
                                        </button>
                                      ))}
                                    </div>
                                    <button
                                      onClick={() =>
                                        setCurrentInterviewedPage(
                                          currentInterviewedPage + 1
                                        )
                                      }
                                      disabled={
                                        currentInterviewedPage ===
                                        totalInterviewedPages
                                      }
                                      className={`relative inline-flex items-center px-4 py-2 border-y border-r border-gray-300 text-sm font-medium rounded-r-md text-gray-700 bg-white hover:text-gray-500 ${currentInterviewedPage ===
                                        totalInterviewedPages
                                        ? "opacity-50"
                                        : "hover:bg-gray-50"
                                        }`}
                                    >
                                      Next
                                    </button>
                                  </div>
                                </nav>
                              </div>
                            )}
                          </>
                        );
                      })}
                      {/* {subtab == 3 &&( <div className="p-6">
                      <div>
                        <Table>
                          <Thead className="top-0  text-center text-sm">
                            <Tr>
                              <Th className="border-y px-4 py-[23px] ">Applicant Name</Th>
                              <Th className="border-y px-4 py-[23px] ">Email</Th>
                              <Th className="border-y px-4 py-[23px] ">phone</Th>
                              <Th className="border-y px-4 py-[23px] ">Interview Date</Th>
                              <Th className="border-y px-4 py-[23px] ">Interviewer</Th>
                              <Th className="border-y px-4 py-[23px] ">
                                <button className="h-full w-full items-center flex text-blue-500 justify-center">
                                  Aggregate Score
                                </button>
                              </Th>
                              <Th className="border-y px-4 py-[23px] ">Average Rating</Th>
                              <Th className="border-y px-4 py-[23px] ">Actions</Th>
                            </Tr>
                          </Thead>
                          <Tbody>
                            {paginatedAll.map((e, i) => {
                              return (
                                <Tr className="text-sm">
                                  <Td className="border-y px-4 py-[23px] ">
                                    <button className="text-blue-500">
                                      {e.name}
                                    </button>
                                  </Td>
                                  <Td className="border-y px-4 py-[23px] ">
                                    <div className="flex flex-col space-y-1 text-center">
                                      <p>
                                        <a
                                          href={`mailto:${e.email}`}
                                          className="text-blue-500"
                                        >
                                          {e.email}
                                        </a>
                                      </p>
                                    </div>
                                  </Td>
                                  <Td className="border-y px-4 py-[23px] text-center">
                                    {e.phone}
                                  </Td>
                                  <Td className="border-y text-center px-4 py-[23px] ">
                                    { e.interviewdate}
                                  </Td>
                                  <Td className="border-y px-4 py-[23px] ">{e.Interviewer}</Td>
                                  <Td className="border-y text-center px-4 py-[23px] ">
                                    {e.aggregate == 0 ? "-" : `${e.aggregate}`}
                                  </Td>
                                  <Td className="border-y px-4 py-[23px] ">
                               { e.ratting == 0 ? '-':<div className="bg-[#FFEBD6] flex justify-center align-center rounded-sm w-[50%] gap-2">
                                {e.ratting}
                                <img src={rating}/>
                                  </div>}
                                  
                                  </Td>

                                  <Td className="border-y px-4 py-[23px] ">
                                      <Select
                                        options={unshortlistOptions}
                                      ></Select>
                                  </Td>
                                </Tr>
                              );
                            })}
                          </Tbody>
                        </Table>
                      </div>
                      <nav className="bg-white mt-4  flex items-center justify-between">
                        <div className="hidden sm:block">
                          {sortedInterview.length !== 0 ? (
                            <p className="text-sm text-gray-700">
                              {indexOfFirstInterviewedApplicant + 1} to{" "}
                              {currentInterviewedPage !== totalInterviewedPages
                                ? indexOfLastInterviewedApplicant
                                : sortedInterview.length}{" "}
                              of {sortedInterview.length} applicant
                            </p>
                          ) : (
                            <p className="text-sm text-gray-700">
                              {0} to {0} of {sortedInterview.length} applicant
                            </p>
                          )}
                        </div>
                        <div className="flex-1 flex justify-between sm:justify-end gap-1">
                          <button
                            onClick={() =>
                              setCurrentInterviewedPage(
                                currentInterviewedPage - 1
                              )
                            }
                            disabled={currentInterviewedPage === 1}
                            className={`relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:text-gray-500 ${
                              currentInterviewedPage === 1
                                ? "opacity-50"
                                : "hover:bg-gray-50"
                            }`}
                          >
                            Previous
                          </button>
                          <div className="flex space-x-2">
                            {getInterviewedPageRange().map((page) => (
                              <button
                                key={page}
                                onClick={() => setCurrentInterviewedPage(page)}
                                className={`relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:text-gray-500 cursor-pointer ${
                                  currentInterviewedPage === page
                                    ? "bg-gray-100"
                                    : "hover:bg-gray-50"
                                }`}
                              >
                                {page}
                              </button>
                            ))}
                          </div>
                          <button
                            onClick={() =>
                              setCurrentInterviewedPage(
                                currentInterviewedPage + 1
                              )
                            }
                            disabled={
                              currentInterviewedPage === totalInterviewedPages
                            }
                            className={`relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:text-gray-500 ${
                              currentInterviewedPage === totalInterviewedPages
                                ? "opacity-50"
                                : "hover:bg-gray-50"
                            }`}
                          >
                            Next
                          </button>
                        </div>
                      </nav>
                    </div>)} */}
                      {subtab == 99 && (
                        <div className="p-6 pt-0">
                          <div>
                            <Table>
                              <Thead className="top-0  text-center text-sm">
                                <Tr>
                                  <Th className="border-y  py-[20px] px-4">
                                    <input
                                      type="checkbox"
                                      className="w-4 h-4"
                                      checked={selectedAll}
                                      onChange={() => {
                                        handleCheckbox();
                                      }}
                                    />
                                  </Th>

                                  <Th className="border-y px-[20px] py-4 text-left ">
                                    Applicant Name
                                  </Th>

                                  <Th className="border-y px-4 py-[23px] ">
                                    <button className="h-full w-full items-center flex  justify-center">
                                      Aggregate AI Score
                                    </button>
                                  </Th>
                                  {Array.from(
                                    { length: roundsNo },
                                    (_, index) => (
                                      <Th
                                        key={index}
                                        className="border-y px-4 py-[23px] "
                                      >
                                        Round {index + 1} Rating
                                      </Th>
                                    )
                                  ).slice(-3)}
                                  <Th className="border-y px-4 py-[23px] ">
                                    Average Rating
                                  </Th>
                                  <Th className="border-y px-4 py-[23px] ">
                                    Salary Fitment
                                  </Th>
                                  <Th className="border-y px-4 py-[23px] ">
                                    Actions
                                  </Th>
                                </Tr>
                              </Thead>
                              <Tbody>
                                {paginatedAll.map((e, i) => {
                                  return (
                                    <Tr className="text-sm">
                                      <Td
                                        className={
                                          "border-y  text-center px-4 py-[23px] "
                                        }
                                      >
                                        <span>
                                          <input
                                            type="checkbox"
                                            className="w-4 h-4"
                                            checked={
                                              selectedRows.includes(e.uuid)
                                                ? true
                                                : false
                                            }
                                            onChange={() =>
                                              handleSelectedRow(e.uuid)
                                            }
                                          />
                                        </span>
                                      </Td>

                                      <Td className="border-y px-[20px] py-4 text-left text-[#148EFF]">
                                        {/* <button className="text-blue-500">
                                  {e.name}
                                </button> */}
                                        <div className="">
                                          <p className="flex items-center ">
                                            <button
                                              className="text-left"
                                              onClick={() => {
                                                navigate(
                                                  "/jobs/candidates/about",
                                                  {
                                                    state: {
                                                      uuid: e.uuid,
                                                      rank:
                                                        indexOfFirstApplicant +
                                                        i +
                                                        1,
                                                    },
                                                  }
                                                );
                                                // sessionStorage.setItem('currentPage', currentPage)
                                              }}
                                            >
                                              {e.name}
                                            </button>
                                            <div className="group relative">
                                              <img
                                                src={mail}
                                                className="h-4 mx-1"
                                              ></img>
                                              <div className="absolute transition-all left-3 top-3 text-left px-[10px] py-[7px] z-20 border-2  border-light-blue scale-0 rounded-lg bg-white w-fit shadow-md text-[9px]  group-hover:scale-100">
                                                <a
                                                  href={`mailto:${e.email}`}
                                                  className="truncate"
                                                >
                                                  {e.email}
                                                </a>
                                              </div>
                                            </div>
                                          </p>
                                          <p className="text-black text-[10px] mt-[2px]">
                                            {e.countrycode} {e.phone}
                                          </p>
                                        </div>
                                      </Td>

                                      <Td className="border-y text-center px-4 py-[23px] ">
                                        {e.aggregate == 0
                                          ? "-"
                                          : `${e.aggregate}`}
                                      </Td>
                                      {e.interviewrating &&
                                        e.interviewrating.length >= roundsNo ? (
                                        e.interviewrating
                                          .slice(-3)
                                          .map((rating, index) => (
                                            <Td
                                              key={index}
                                              className="border-y px-4 py-[23px] text-center"
                                            >
                                              <div className="flex gap-2 justify-center items-center text-[#FE7F00] font-semibold">
                                                {rating != null ? (
                                                  <>
                                                    {rating}
                                                    <img
                                                      className="w-3 h-3"
                                                      src={rattingstar}
                                                      alt="Rating Star"
                                                    />
                                                  </>
                                                ) : (
                                                  "-"
                                                )}
                                              </div>
                                            </Td>
                                          ))
                                      ) : (
                                        <>
                                          <Td className="border-y px-4 py-[23px] text-center">
                                            -
                                          </Td>
                                          <Td className="border-y px-4 py-[23px] text-center">
                                            -
                                          </Td>
                                          <Td className="border-y px-4 py-[23px] text-center">
                                            -
                                          </Td>
                                        </>
                                      )}

                                      <Td className="border-y px-4 py-[23px] text-center">
                                        <div className="flex justify-center">
                                          <div className="flex justify-center">
                                            <div className="bg-[#FFEBD6] flex justify-center items-center align-center rounded p-[.1rem] px-3 gap-2">
                                              <p className="text-[#FE7F00] font-semibold ">
                                                {calculateAverageRating(
                                                  e.interviewrating
                                                )}
                                              </p>
                                              <img
                                                className="w-3 h-3"
                                                src={rattingstar}
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </Td>
                                      <Td className="text-center border-y px-4 py-[23px] relative">
                                        <div className="group  flex justify-center">
                                          <button>
                                            {parseInt(
                                              e?.expectedsalary
                                                ?.split(" ")[1]
                                                ?.replaceAll(",", "")
                                            ) < minSalary && (
                                                <div className="text-[#8F94A1]">
                                                  <p className="text-[0.6rem]">
                                                    Below Range
                                                  </p>
                                                  <div className="bg-[#E9EBFA] h-[0.5rem] relative my-1 rounded-lg w-[3.9rem] mx-auto">
                                                    <div
                                                      className={`absolute bg-[#8F94A1] h-[0.5rem] rounded-lg`}
                                                      style={{ width: `33%` }}
                                                    ></div>
                                                  </div>
                                                </div>
                                              )}
                                            {parseInt(
                                              e?.expectedsalary
                                                ?.split(" ")[1]
                                                ?.replaceAll(",", "")
                                            ) >= minSalary &&
                                              parseInt(
                                                e?.expectedsalary
                                                  ?.split(" ")[1]
                                                  ?.replaceAll(",", "")
                                              ) <= maxSalary && (
                                                <div className="text-[#40B2B7]">
                                                  <p className="text-[0.7rem]">
                                                    Within Range
                                                  </p>
                                                  <div className="bg-[#E9EBFA] h-[0.5rem] relative my-1 rounded-lg w-[3.9rem] mx-auto">
                                                    <div
                                                      className={`absolute bg-[#40B2B7] h-[0.5rem] rounded-lg`}
                                                      style={{ width: `50%` }}
                                                    ></div>
                                                  </div>
                                                </div>
                                              )}
                                            {parseInt(
                                              e?.expectedsalary
                                                ?.split(" ")[1]
                                                ?.replaceAll(",", "")
                                            ) > maxSalary && (
                                                <div className="text-[#E95060]">
                                                  <p className="text-[0.7rem]">
                                                    Above Range
                                                  </p>
                                                  <div className="bg-[#E9EBFA] h-[0.5rem] relative my-1 rounded-lg w-[3.9rem] mx-auto">
                                                    <div
                                                      className={`absolute bg-[#E95060] h-[0.5rem] rounded-lg`}
                                                      style={{ width: `66%` }}
                                                    ></div>
                                                  </div>
                                                </div>
                                              )}
                                            {!e.expectedsalary && <p>-</p>}
                                          </button>
                                          {parseInt(
                                            e?.expectedsalary
                                              ?.split(" ")[1]
                                              ?.replaceAll(",", "")
                                          ) < minSalary && (
                                              <div
                                                textv
                                                className="absolute transition-all left-11 top-16   px-[10px] py-[7px] text-left shadow-md z-20 border-2 whitespace-nowrap border-[#8F94A1]  scale-0 rounded-lg bg-white  text-[9px]  group-hover:scale-100"
                                              >
                                                <p className="mb-1 gap-[4px] flex">
                                                  <b>Current Salary: </b>
                                                  <span>{e.currentsalary}</span>
                                                </p>
                                                <p className="flex gap-[4px]">
                                                  <b>Expected Salary: </b>
                                                  <span>{e.expectedsalary}</span>
                                                </p>
                                              </div>
                                            )}
                                          {parseInt(
                                            e?.expectedsalary
                                              ?.split(" ")[1]
                                              ?.replaceAll(",", "")
                                          ) > minSalary &&
                                            parseInt(
                                              e?.expectedsalary
                                                ?.split(" ")[1]
                                                ?.replaceAll(",", "")
                                            ) < maxSalary && (
                                              <div
                                                textv
                                                className="absolute transition-all left-11 top-16   px-[10px] py-[7px] text-left shadow-md z-20 border-2 whitespace-nowrap border-[#40B2B7]  scale-0 rounded-lg bg-white  text-[9px]  group-hover:scale-100"
                                              >
                                                <p className="mb-1 gap-[4px] flex">
                                                  <b>Current Salary: </b>
                                                  <span>{e.currentsalary}</span>
                                                </p>
                                                <p className="flex gap-[4px]">
                                                  <b>Expected Salary: </b>
                                                  <span>
                                                    {e.expectedsalary}
                                                  </span>
                                                </p>
                                              </div>
                                            )}
                                          {parseInt(
                                            e?.expectedsalary
                                              ?.split(" ")[1]
                                              ?.replaceAll(",", "")
                                          ) > maxSalary && (
                                              <div
                                                textv
                                                className="absolute transition-all left-11 top-16   px-[10px] py-[7px] text-left shadow-md z-20 border-2 whitespace-nowrap border-[#E95060]  scale-0 rounded-lg bg-white  text-[9px]  group-hover:scale-100"
                                              >
                                                <p className="mb-1 gap-[4px] flex">
                                                  <b>Current Salary: </b>
                                                  <span>{e.currentsalary}</span>
                                                </p>
                                                <p className="flex gap-[4px]">
                                                  <b>Expected Salary: </b>
                                                  <span>{e.expectedsalary}</span>
                                                </p>
                                              </div>
                                            )}
                                        </div>
                                      </Td>
                                      <Td className="border-y px-4 py-[23px] text-left w-[170px] text-[12px]">
                                        <Select
                                          value={popUpValue}
                                          onChange={(option) => {
                                            setSelectedModalIsOpen(
                                              option.value
                                            );
                                            setStatus(e.status);
                                            setActiveUuid(e.uuid);
                                          }}
                                          options={selectedOption}
                                          placeholder="Select Action"
                                        ></Select>
                                      </Td>
                                    </Tr>
                                  );
                                })}
                              </Tbody>
                            </Table>
                          </div>
                          <nav className="bg-white mt-4  flex items-center justify-between">
                            <div className="hidden sm:block">
                              <div className="flex items-center text-[14px] font-normal z-10 gap-2">
                                Show
                                <Select
                                  placeholder={itemsPerPage}
                                  options={perPageOptions}
                                  className="z-20 text-[14px] page-select  "
                                  onChange={(selectedOption) => {
                                    setItemsPerPage(selectedOption.value);
                                  }}
                                  menuPlacement="top"
                                />
                                entries
                              </div>
                            </div>
                            <div className="flex-1 flex justify-between sm:justify-end ">
                              <button
                                onClick={() =>
                                  setCurrentInterviewedPage(
                                    currentInterviewedPage - 1
                                  )
                                }
                                disabled={currentInterviewedPage === 1}
                                className={`relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-l-md text-gray-700 bg-white hover:text-gray-500 ${currentInterviewedPage === 1
                                  ? "opacity-50"
                                  : "hover:bg-gray-50"
                                  }`}
                              >
                                Previous
                              </button>
                              <div className="flex ">
                                {getInterviewedPageRange().map((page) => (
                                  <button
                                    key={page}
                                    onClick={() =>
                                      setCurrentInterviewedPage(page)
                                    }
                                    className={`relative inline-flex items-center px-4 py-2 border-y border-r border-gray-300 text-sm font-medium  text-gray-700   cursor-pointer ${currentInterviewedPage === page
                                      ? "bg-light-blue text-white"
                                      : ""
                                      }`}
                                  >
                                    {page}
                                  </button>
                                ))}
                              </div>
                              <button
                                onClick={() =>
                                  setCurrentInterviewedPage(
                                    currentInterviewedPage + 1
                                  )
                                }
                                disabled={
                                  currentInterviewedPage ===
                                  totalInterviewedPages
                                }
                                className={`relative inline-flex items-center px-4 py-2 border-y border-r border-gray-300 text-sm font-medium rounded-r-md text-gray-700 bg-white hover:text-gray-500 ${currentInterviewedPage ===
                                  totalInterviewedPages
                                  ? "opacity-50"
                                  : "hover:bg-gray-50"
                                  }`}
                              >
                                Next
                              </button>
                            </div>
                          </nav>
                        </div>
                      )}
                    </div>
                  </>
                )}
                {select == 2 && (
                  <>
                    <div>
                      <Table>
                        <Thead className="top-0  text-center text-sm">
                          <Tr>
                            <Th className="border-y px-4 py-[20px]">Rank</Th>
                            <Th className="border-y px-[20px] py-4 text-left ">
                              Applicant Name
                            </Th>
                            <Th className="border-y px-4 py-[23px] ">
                              <button className="h-full w-full flex items-center text-blue-500 justify-center ">
                                Resume Compatibility Score
                              </button>
                            </Th>
                            <Th className="border-y px-4 py-[23px] ">
                              <button className="h-full w-full flex items-center text-blue-500 justify-center">
                                Soft Skills Score
                              </button>
                            </Th>

                            <Th className="border-y px-4 py-[23px] ">
                              <button className="h-full w-full flex items-center text-blue-500 justify-center">
                                Technical Score
                              </button>
                            </Th>

                            <Th className="border-y px-4 py-[23px] ">
                              <button className="h-full w-full flex items-center text-blue-500 justify-center">
                                Voice Analysis Score
                              </button>
                            </Th>
                            <Th className="border-y px-4 py-[23px] ">
                              <button className="h-full w-full items-center flex text-blue-500 justify-center">
                                Aggregate Score
                              </button>
                            </Th>
                            <Th className="border-y px-4 py-[23px] ">Status</Th>
                            <Th className="border-y px-4 py-[23px] ">
                              Contact
                            </Th>
                            <Th className="border-y px-4 py-[23px] ">
                              Actions
                            </Th>
                          </Tr>
                        </Thead>
                        <Tbody>
                          {paginatedAll.map((e, i) => {
                            return (
                              <Tr className="text-sm">
                                <Td
                                  className={
                                    "border  text-center px-4 py-[23px] "
                                  }
                                >
                                  <div>{i + 1}</div>
                                </Td>
                                <Td className="border-y px-4 py-[23px] ">
                                  <button className="text-blue-500">
                                    {e.name}
                                  </button>
                                </Td>
                                <Td className="border-y px-4 py-[23px] text-center">
                                  {e.resumescore}
                                </Td>
                                <Td className="border-y px-4 py-[23px] text-center">
                                  {e.aiscore == 0 ? "-" : `${e.aiscore}`}
                                </Td>

                                <Td className="border-y px-4 py-[23px] text-center">
                                  {e.technicalscore == 0
                                    ? "-"
                                    : `${e.technicalscore}`}
                                </Td>

                                <Td className="border-y px-4 py-[23px] text-center">
                                  {e.voiceanalysisscore == 0
                                    ? "-"
                                    : `${e.voiceanalysisscore}`}
                                </Td>
                                <Td className="border-y text-center px-4 py-[23px] ">
                                  {e.aggregate == 0 ? "-" : `${e.aggregate}`}
                                </Td>
                                <Td className="border-y px-4 py-[23px] ">
                                  {e.status}
                                </Td>
                                <Td className="border-y px-4 py-[23px] ">
                                  <div className="flex flex-col space-y-1 text-center">
                                    <p>
                                      <a
                                        href={`mailto:${e.email}`}
                                        className="text-blue-500"
                                      >
                                        {e.email}
                                      </a>
                                    </p>
                                    <p>
                                      <span className="text-blue-500">
                                        {e.phone}
                                      </span>
                                    </p>
                                  </div>
                                </Td>
                                <Td className="border-y px-4 py-[23px] text-left w-[170px] text-[12px]">
                                  {e.status != "Shortlisted" ? (
                                    <Select
                                      options={options}
                                      placeholder="Select Action"
                                    ></Select>
                                  ) : (
                                    <Select
                                      options={unshortlistOptions}
                                      placeholder="Select Action"
                                    ></Select>
                                  )}
                                </Td>
                              </Tr>
                            );
                          })}
                        </Tbody>
                      </Table>
                    </div>
                    <nav className="bg-white mt-4  flex items-center justify-between">
                      <div className="hidden sm:block">
                        <div className="flex items-center text-[14px] font-normal z-10 gap-2">
                          Show
                          <Select
                            options={perPageOptions}
                            className="z-20 text-[14px] page-select  "
                            onChange={(selectedOption) => {
                              setItemsPerPage(selectedOption.value);
                            }}
                            menuPlacement="top"
                          />
                          entries
                        </div>
                      </div>
                      <div className="flex-1 flex justify-between sm:justify-end ">
                        <button
                          onClick={() =>
                            setCurrentInterviewedPage(
                              currentInterviewedPage - 1
                            )
                          }
                          disabled={currentInterviewedPage === 1}
                          className={`relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-l-md text-gray-700 bg-white hover:text-gray-500 ${currentInterviewedPage === 1
                            ? "opacity-50"
                            : "hover:bg-gray-50"
                            }`}
                        >
                          Previous
                        </button>
                        <div className="flex ">
                          {getInterviewedPageRange().map((page) => (
                            <button
                              key={page}
                              onClick={() => setCurrentInterviewedPage(page)}
                              className={`relative inline-flex items-center px-4 py-2 border-y border-r border-gray-300 text-sm font-medium  text-gray-700   cursor-pointer ${currentInterviewedPage === page
                                ? "bg-light-blue text-white"
                                : ""
                                }`}
                            >
                              {page}
                            </button>
                          ))}
                        </div>
                        <button
                          onClick={() =>
                            setCurrentInterviewedPage(
                              currentInterviewedPage + 1
                            )
                          }
                          disabled={
                            currentInterviewedPage === totalInterviewedPages
                          }
                          className={`relative inline-flex items-center px-4 py-2 border-y border-r border-gray-300 text-sm font-medium rounded-r-md text-gray-700 bg-white hover:text-gray-500 ${currentInterviewedPage === totalInterviewedPages
                            ? "opacity-50"
                            : "hover:bg-gray-50"
                            }`}
                        >
                          Next
                        </button>
                      </div>
                    </nav>
                  </>
                )}
                {select == 3 && (
                  <>
                    <div>
                      <Table>
                        <Thead className="top-0  text-center text-sm">
                          <Tr>
                            <Th className="border-y  px-4 py-[20px]">Rank</Th>
                            <Th className="border-y px-[20px] py-4 text-left ">
                              Applicant Name
                            </Th>
                            <Th className="border-y px-4 py-[23px] ">
                              <button className="h-full w-full flex items-center text-blue-500 justify-center ">
                                Resume Compatibility Score
                              </button>
                            </Th>
                            <Th className="border-y px-4 py-[23px] ">
                              <button className="h-full w-full flex items-center text-blue-500 justify-center">
                                Soft Skills Score
                              </button>
                            </Th>

                            <Th className="border-y px-4 py-[23px] ">
                              <button className="h-full w-full flex items-center text-blue-500 justify-center">
                                Technical Score
                              </button>
                            </Th>

                            <Th className="border-y px-4 py-[23px] ">
                              <button className="h-full w-full flex items-center text-blue-500 justify-center">
                                Voice Analysis Score
                              </button>
                            </Th>
                            <Th className="border-y px-4 py-[23px] ">
                              <button className="h-full w-full items-center flex text-blue-500 justify-center">
                                Aggregate Score
                              </button>
                            </Th>
                            <Th className="border-y px-4 py-[23px] ">Status</Th>
                            <Th className="border-y px-4 py-[23px] ">
                              Contact
                            </Th>
                            <Th className="border-y px-4 py-[23px] ">
                              Actions
                            </Th>
                          </Tr>
                        </Thead>
                        <Tbody>
                          {paginatedAll.map((e, i) => {
                            return (
                              <Tr className="text-sm">
                                <Td
                                  className={
                                    "border  text-center px-4 py-[23px] "
                                  }
                                >
                                  <div>{i + 1}</div>
                                </Td>
                                <Td className="border-y px-4 py-[23px] ">
                                  <button className="text-blue-500">
                                    {e.name}
                                  </button>
                                </Td>
                                <Td className="border-y px-4 py-[23px] text-center">
                                  {e.resumescore}
                                </Td>
                                <Td className="border-y px-4 py-[23px] text-center">
                                  {e.aiscore == 0 ? "-" : `${e.aiscore}`}
                                </Td>

                                <Td className="border-y px-4 py-[23px] text-center">
                                  {e.technicalscore == 0
                                    ? "-"
                                    : `${e.technicalscore}`}
                                </Td>

                                <Td className="border-y px-4 py-[23px] text-center">
                                  {e.voiceanalysisscore == 0
                                    ? "-"
                                    : `${e.voiceanalysisscore}`}
                                </Td>
                                <Td className="border-y text-center px-4 py-[23px] ">
                                  {e.aggregate == 0 ? "-" : `${e.aggregate}`}
                                </Td>
                                <Td className="border-y px-4 py-[23px] ">
                                  {e.status}
                                </Td>
                                <Td className="border-y px-4 py-[23px] ">
                                  <div className="flex flex-col space-y-1 text-center">
                                    <p>
                                      <a
                                        href={`mailto:${e.email}`}
                                        className="text-blue-500"
                                      >
                                        {e.email}
                                      </a>
                                    </p>
                                    <p>
                                      <span className="text-blue-500">
                                        {e.phone}
                                      </span>
                                    </p>
                                  </div>
                                </Td>
                                <Td className="border-y px-4 py-[23px] text-left w-[170px] text-[12px]">
                                  {e.status != "Shortlisted" ? (
                                    <Select
                                      options={options}
                                      placeholder="Select Action"
                                    ></Select>
                                  ) : (
                                    <Select
                                      options={unshortlistOptions}
                                      placeholder="Select Action"
                                    ></Select>
                                  )}
                                </Td>
                              </Tr>
                            );
                          })}
                        </Tbody>
                      </Table>
                    </div>
                    <nav className="bg-white mt-4  flex items-center justify-between">
                      <div className="hidden sm:block">
                        <div className="flex items-center text-[14px] font-normal z-10 gap-2">
                          Show
                          <Select
                            placeholder={itemsPerPage}
                            options={perPageOptions}
                            className="z-20 text-[14px] page-select  "
                            onChange={(selectedOption) => {
                              setItemsPerPage(selectedOption.value);
                            }}
                            menuPlacement="top"
                          />
                          entries
                        </div>
                      </div>
                      <div className="flex-1 flex justify-between sm:justify-end ">
                        <button
                          onClick={() =>
                            setCurrentInterviewedPage(
                              currentInterviewedPage - 1
                            )
                          }
                          disabled={currentInterviewedPage === 1}
                          className={`relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-l-md text-gray-700 bg-white hover:text-gray-500 ${currentInterviewedPage === 1
                            ? "opacity-50"
                            : "hover:bg-gray-50"
                            }`}
                        >
                          Previous
                        </button>
                        <div className="flex ">
                          {getInterviewedPageRange().map((page) => (
                            <button
                              key={page}
                              onClick={() => setCurrentInterviewedPage(page)}
                              className={`relative inline-flex items-center px-4 py-2 border-y border-r border-gray-300 text-sm font-medium  text-gray-700   cursor-pointer ${currentInterviewedPage === page
                                ? "bg-light-blue text-white"
                                : ""
                                }`}
                            >
                              {page}
                            </button>
                          ))}
                        </div>
                        <button
                          onClick={() =>
                            setCurrentInterviewedPage(
                              currentInterviewedPage + 1
                            )
                          }
                          disabled={
                            currentInterviewedPage === totalInterviewedPages
                          }
                          className={`relative inline-flex items-center px-4 py-2 border-y border-r border-gray-300 text-sm font-medium rounded-r-md text-gray-700 bg-white hover:text-gray-500 ${currentInterviewedPage === totalInterviewedPages
                            ? "opacity-50"
                            : "hover:bg-gray-50"
                            }`}
                        >
                          Next
                        </button>
                      </div>
                    </nav>
                  </>
                )}
                {select == 4 && (
                  <>
                    <div>
                      <Table>
                        <Thead className="top-0  text-center text-sm">
                          <Tr>
                            <Th className="border-y  py-[20px] px-4">
                              <input
                                type="checkbox"
                                className="w-4 h-4"
                                checked={selectedAll}
                                onChange={() => {
                                  handleCheckbox();
                                }}
                              />
                            </Th>

                            <Th className="border-y text-left px-[20px] py-4  ">
                              Applicant Name
                            </Th>

                            <Th className="border-y px-4 py-[23px] ">
                              <button className="h-full w-full items-center flex  justify-center">
                                Aggregate AI Score
                              </button>
                            </Th>
                            {Array.from({ length: roundsNo }, (_, index) => (
                              <Th
                                key={index}
                                className="border-y px-4 py-[23px] "
                              >
                                Round {index + 1} Rating
                              </Th>
                            )).slice(-2)}
                            <Th className="border-y px-4 py-[23px] ">
                              Average Rating
                            </Th>
                            <Th className="border-y px-4 py-[23px] ">
                              Salary Fitment
                            </Th>
                            <Th className="border-y px-4 py-[23px] ">
                              Actions
                            </Th>
                          </Tr>
                        </Thead>
                        <Tbody>
                          {paginatedAll.map((e, i) => {
                            return (
                              <Tr className="text-sm">
                                <Td
                                  className={
                                    "border-y  text-center px-4 py-[23px] "
                                  }
                                >
                                  <span>
                                    <input
                                      type="checkbox"
                                      className="w-4 h-4"
                                      checked={
                                        selectedRows.includes(e.uuid)
                                          ? true
                                          : false
                                      }
                                      onChange={() => handleSelectedRow(e.uuid)}
                                    />
                                  </span>
                                </Td>

                                <Td className="border-y px-[20px] py-4  text-left text-[#148EFF]">
                                  {/* <button className="text-blue-500">
                                  {e.name}
                                </button> */}
                                  <div className="">
                                    <p className="flex items-center ">
                                      <button
                                        className="text-left"
                                        onClick={() => {
                                          navigate("/jobs/candidates/about", {
                                            state: {
                                              uuid: e.uuid,
                                              rank:
                                                indexOfFirstApplicant + i + 1,
                                            },
                                          });
                                          // sessionStorage.setItem('currentPage', currentPage)
                                        }}
                                      >
                                        {e.name}
                                      </button>
                                      <div className="group relative">
                                        <img
                                          src={mail}
                                          className="h-4 mx-1"
                                        ></img>
                                        <div className="absolute transition-all left-3 top-3 text-left px-[10px] py-[7px] z-20 border-2  border-light-blue scale-0 rounded-lg bg-white w-fit shadow-md text-[9px]  group-hover:scale-100">
                                          <a
                                            href={`mailto:${e.email}`}
                                            className="truncate"
                                          >
                                            {e.email}
                                          </a>
                                        </div>
                                      </div>
                                    </p>
                                    <p className="text-black text-[10px] mt-[2px]">
                                      {e.countrycode} {e.phone}
                                    </p>
                                  </div>
                                </Td>

                                <Td className="border-y text-center px-4 py-[23px] ">
                                  {e.aggregate == 0 ? "-" : `${e.aggregate}`}
                                </Td>
                                {e.interviewrating &&
                                  e.interviewrating.length >= roundsNo ? (
                                  e.interviewrating
                                    .slice(-2)
                                    .map((rating, index) => (
                                      <Td
                                        key={index}
                                        className="border-y px-4 py-[23px] text-center  text-[#FE7F00] font-semibold"
                                      >
                                        <div className="flex gap-2 justify-center items-center">
                                          {rating != null ? (
                                            <>
                                              {rating}
                                              <img
                                                className="w-3 h-3"
                                                src={rattingstar}
                                                alt="Rating Star"
                                              />
                                            </>
                                          ) : (
                                            "-"
                                          )}
                                        </div>
                                      </Td>
                                    ))
                                ) : (
                                  <>
                                    <Td className="border-y px-4 py-[23px] text-center">
                                      -
                                    </Td>
                                    <Td className="border-y px-4 py-[23px] text-center">
                                      -
                                    </Td>
                                  </>
                                )}
                                <Td className="border-y px-4 py-[23px] text-center">
                                  <div className="flex justify-center">
                                    <div className="bg-[#FFEBD6] flex justify-center text-[#FE7F00] font-semibold  items-center align-center rounded p-[.1rem] px-3 gap-2">
                                      {e.interviewrating != null ? (
                                        <p className="">
                                          {calculateAverageRating(
                                            e.interviewrating
                                          )}
                                        </p>
                                      ) : (
                                        "0"
                                      )}
                                      <img
                                        className="w-3 h-3"
                                        src={rattingstar}
                                      />
                                    </div>
                                  </div>
                                </Td>
                                <Td className="text-center border-y px-4 py-[23px] relative">
                                  <div className="group  flex justify-center">
                                    <button>
                                      {parseInt(
                                        e?.expectedsalary
                                          ?.split(" ")[1]
                                          ?.replaceAll(",", "")
                                      ) < minSalary && (
                                          <div className="text-[#8F94A1]">
                                            <p className="text-[0.6rem]">
                                              Below Range
                                            </p>
                                            <div className="bg-[#E9EBFA] h-[0.5rem] relative my-1 rounded-lg w-[3.9rem] mx-auto">
                                              <div
                                                className={`absolute bg-[#8F94A1] h-[0.5rem] rounded-lg`}
                                                style={{ width: `33%` }}
                                              ></div>
                                            </div>
                                          </div>
                                        )}
                                      {parseInt(
                                        e?.expectedsalary
                                          ?.split(" ")[1]
                                          ?.replaceAll(",", "")
                                      ) >= minSalary &&
                                        parseInt(
                                          e?.expectedsalary
                                            ?.split(" ")[1]
                                            ?.replaceAll(",", "")
                                        ) <= maxSalary && (
                                          <div className="text-[#40B2B7]">
                                            <p className="text-[0.7rem]">
                                              Within Range
                                            </p>
                                            <div className="bg-[#E9EBFA] h-[0.5rem] relative my-1 rounded-lg w-[3.9rem] mx-auto">
                                              <div
                                                className={`absolute bg-[#40B2B7] h-[0.5rem] rounded-lg`}
                                                style={{ width: `50%` }}
                                              ></div>
                                            </div>
                                          </div>
                                        )}
                                      {parseInt(
                                        e?.expectedsalary
                                          ?.split(" ")[1]
                                          ?.replaceAll(",", "")
                                      ) > maxSalary && (
                                          <div className="text-[#E95060]">
                                            <p className="text-[0.7rem]">
                                              Above Range
                                            </p>
                                            <div className="bg-[#E9EBFA] h-[0.5rem] relative my-1 rounded-lg w-[3.9rem] mx-auto">
                                              <div
                                                className={`absolute bg-[#E95060] h-[0.5rem] rounded-lg`}
                                                style={{ width: `66%` }}
                                              ></div>
                                            </div>
                                          </div>
                                        )}
                                      {!e.expectedsalary && <p>-</p>}
                                    </button>
                                    {parseInt(
                                      e?.expectedsalary
                                        ?.split(" ")[1]
                                        ?.replaceAll(",", "")
                                    ) < minSalary && (
                                        <div
                                          textv
                                          className="absolute transition-all left-11 top-16   px-[10px] py-[7px] text-left shadow-md z-20 border-2 whitespace-nowrap border-[#8F94A1]  scale-0 rounded-lg bg-white  text-[9px]  group-hover:scale-100"
                                        >
                                          <p className="mb-1 gap-[4px] flex">
                                            <b>Current Salary: </b>
                                            <span>{e.currentsalary}</span>
                                          </p>
                                          <p className="flex gap-[4px]">
                                            <b>Expected Salary: </b>
                                            <span>{e.expectedsalary}</span>
                                          </p>
                                        </div>
                                      )}
                                    {parseInt(
                                      e?.expectedsalary
                                        ?.split(" ")[1]
                                        ?.replaceAll(",", "")
                                    ) > minSalary &&
                                      parseInt(
                                        e?.expectedsalary
                                          ?.split(" ")[1]
                                          ?.replaceAll(",", "")
                                      ) < maxSalary && (
                                        <div
                                          textv
                                          className="absolute transition-all left-11 top-16   px-[10px] py-[7px] text-left shadow-md z-20 border-2 whitespace-nowrap border-[#40B2B7]  scale-0 rounded-lg bg-white  text-[9px]  group-hover:scale-100"
                                        >
                                          <p className="mb-1 gap-[4px] flex">
                                            <b>Current Salary: </b>
                                            <span>{e.currentsalary}</span>
                                          </p>
                                          <p className="flex gap-[4px]">
                                            <b>Expected Salary: </b>
                                            <span>{e.expectedsalary}</span>
                                          </p>
                                        </div>
                                      )}
                                    {parseInt(
                                      e?.expectedsalary
                                        ?.split(" ")[1]
                                        ?.replaceAll(",", "")
                                    ) > maxSalary && (
                                        <div
                                          textv
                                          className="absolute transition-all left-11 top-16   px-[10px] py-[7px] text-left shadow-md z-20 border-2 whitespace-nowrap border-[#E95060]  scale-0 rounded-lg bg-white  text-[9px]  group-hover:scale-100"
                                        >
                                          <p className="mb-1 gap-[4px] flex">
                                            <b>Current Salary: </b>
                                            <span>{e.currentsalary}</span>
                                          </p>
                                          <p className="flex gap-[4px]">
                                            <b>Expected Salary: </b>
                                            <span>{e.expectedsalary}</span>
                                          </p>
                                        </div>
                                      )}
                                  </div>
                                </Td>
                                <Td className="border-y px-4 py-[23px] text-left w-[170px] text-[12px]">
                                  <Select
                                    value={popUpValue}
                                    onChange={(option) => {
                                      setSelectedModalIsOpen(option.value);
                                      setStatus(e.status);
                                      setActiveUuid(e.uuid);
                                    }}
                                    options={onHoldOptions}
                                    placeholder="Select Action"
                                  ></Select>
                                </Td>
                              </Tr>
                            );
                          })}
                        </Tbody>
                      </Table>
                    </div>
                    <nav className="bg-white mt-4  flex items-center justify-between">
                      <div className="hidden sm:block">
                        <div className="flex items-center text-[14px] font-normal z-10 gap-2">
                          Show
                          <Select
                            placeholder={itemsPerPage}
                            options={perPageOptions}
                            className="z-20 text-[14px] page-select  "
                            onChange={(selectedOption) => {
                              setItemsPerPage(selectedOption.value);
                            }}
                            menuPlacement="top"
                          />
                          entries
                        </div>
                      </div>
                      <div className="flex-1 flex justify-between sm:justify-end ">
                        <button
                          onClick={() =>
                            setCurrentInterviewedPage(
                              currentInterviewedPage - 1
                            )
                          }
                          disabled={currentInterviewedPage === 1}
                          className={`relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-l-md text-gray-700 bg-white hover:text-gray-500 ${currentInterviewedPage === 1
                            ? "opacity-50"
                            : "hover:bg-gray-50"
                            }`}
                        >
                          Previous
                        </button>
                        <div className="flex ">
                          {getInterviewedPageRange().map((page) => (
                            <button
                              key={page}
                              onClick={() => setCurrentInterviewedPage(page)}
                              className={`relative inline-flex items-center px-4 py-2 border-y border-r border-gray-300 text-sm font-medium  text-gray-700   cursor-pointer ${currentInterviewedPage === page
                                ? "bg-light-blue text-white"
                                : ""
                                }`}
                            >
                              {page}
                            </button>
                          ))}
                        </div>
                        <button
                          onClick={() =>
                            setCurrentInterviewedPage(
                              currentInterviewedPage + 1
                            )
                          }
                          disabled={
                            currentInterviewedPage === totalInterviewedPages
                          }
                          className={`relative inline-flex items-center px-4 py-2 border-y border-r border-gray-300 text-sm font-medium rounded-r-md text-gray-700 bg-white hover:text-gray-500 ${currentInterviewedPage === totalInterviewedPages
                            ? "opacity-50"
                            : "hover:bg-gray-50"
                            }`}
                        >
                          Next
                        </button>
                      </div>
                    </nav>
                  </>
                )}
                {select == 5 && (
                  <>
                    <div>
                      <Table>
                        <Thead className="top-0  text-center text-sm">
                          <Tr>
                            <Th className="border-y  py-[20px] px-4">
                              <input
                                type="checkbox"
                                className="w-4 h-4"
                                checked={selectedAll}
                                onChange={() => {
                                  handleCheckbox();
                                }}
                              />
                            </Th>

                            <Th className="border-y px-[20px] py-4 text-left ">
                              Applicant Name
                            </Th>

                            <Th className="border-y px-4 py-[23px] ">
                              <button className="h-full w-full items-center flex  justify-center">
                                Aggregate AI Score
                              </button>
                            </Th>
                            {Array.from({ length: roundsNo }, (_, index) => (
                              <Th
                                key={index}
                                className="border-y px-4 py-[23px] "
                              >
                                Round {index + 1} Rating
                              </Th>
                            )).slice(-2)}
                            <Th className="border-y px-4 py-[23px] ">
                              Average Rating
                            </Th>
                            <Th className="border-y px-4 py-[23px] ">
                              Salary Fitment
                            </Th>
                            <Th className="border-y px-4 py-[23px] ">
                              Actions
                            </Th>
                          </Tr>
                        </Thead>
                        <Tbody>
                          {paginatedAll.map((e, i) => {
                            return (
                              <Tr className="text-sm">
                                <Td
                                  className={
                                    "border-y  text-center px-4 py-[23px] "
                                  }
                                >
                                  <span>
                                    <input
                                      type="checkbox"
                                      className="w-4 h-4"
                                      checked={
                                        selectedRows.includes(e.uuid)
                                          ? true
                                          : false
                                      }
                                      onChange={() => handleSelectedRow(e.uuid)}
                                    />
                                  </span>
                                </Td>

                                <Td className="border-y px-[20px] py-4 text-left text-[#148EFF]">
                                  {/* <button className="text-blue-500">
                                  {e.name}
                                </button> */}
                                  <div className="">
                                    <p className="flex items-center ">
                                      <button
                                        className="text-left"
                                        onClick={() => {
                                          navigate("/jobs/candidates/about", {
                                            state: {
                                              uuid: e.uuid,
                                              rank:
                                                indexOfFirstApplicant + i + 1,
                                            },
                                          });
                                          // sessionStorage.setItem('currentPage', currentPage)
                                        }}
                                      >
                                        {e.name}
                                      </button>
                                      <div className="group relative">
                                        <img
                                          src={mail}
                                          className="h-4 mx-1"
                                        ></img>
                                        <div className="absolute transition-all left-3 top-3 text-left px-[10px] py-[7px] z-20 border-2  border-light-blue scale-0 rounded-lg bg-white w-fit shadow-md text-[9px]  group-hover:scale-100">
                                          <a
                                            href={`mailto:${e.email}`}
                                            className="truncate"
                                          >
                                            {e.email}
                                          </a>
                                        </div>
                                      </div>
                                    </p>
                                    <p className="text-black text-[10px] mt-[2px]">
                                      {e.countrycode} {e.phone}
                                    </p>
                                  </div>
                                </Td>

                                <Td className="border-y text-center px-4 py-[23px] ">
                                  {e.aggregate == 0 ? "-" : `${e.aggregate}`}
                                </Td>
                                {e.interviewrating &&
                                  e.interviewrating.length >= roundsNo ? (
                                  e.interviewrating
                                    .slice(-2)
                                    .map((rating, index) => (
                                      <Td
                                        key={index}
                                        className="border-y px-4 py-[23px] text-center text-[#FE7F00] font-semibold"
                                      >
                                        <div className="flex gap-2 justify-center items-center ">
                                          {rating != null ? (
                                            <>
                                              {rating}
                                              <img
                                                className="w-3 h-3"
                                                src={rattingstar}
                                                alt="Rating Star"
                                              />
                                            </>
                                          ) : (
                                            "-"
                                          )}
                                        </div>
                                      </Td>
                                    ))
                                ) : (
                                  <>
                                    <Td className="border-y px-4 py-[23px] text-center">
                                      -
                                    </Td>
                                    <Td className="border-y px-4 py-[23px] text-center">
                                      -
                                    </Td>
                                  </>
                                )}
                                <Td className="border-y px-4 py-[23px] text-center">
                                  <div className="flex justify-center">
                                    <div className="bg-[#FFEBD6] flex justify-center items-center text-[#FE7F00] font-semibold align-center rounded p-[.1rem] px-3 gap-2">
                                      {e.interviewrating != null ? (
                                        <p className=" ">
                                          {calculateAverageRating(
                                            e.interviewrating
                                          )}
                                        </p>
                                      ) : (
                                        "0"
                                      )}
                                      <img
                                        className="w-3 h-3"
                                        src={rattingstar}
                                      />
                                    </div>
                                  </div>
                                </Td>
                                <Td className="text-center border-y px-4 py-[23px] relative">
                                  <div className="group  flex justify-center">
                                    <button>
                                      {parseInt(
                                        e?.expectedsalary
                                          ?.split(" ")[1]
                                          ?.replaceAll(",", "")
                                      ) < minSalary && (
                                          <div className="text-[#8F94A1]">
                                            <p className="text-[0.6rem]">
                                              Below Range
                                            </p>
                                            <div className="bg-[#E9EBFA] h-[0.5rem] relative my-1 rounded-lg w-[3.9rem] mx-auto">
                                              <div
                                                className={`absolute bg-[#8F94A1] h-[0.5rem] rounded-lg`}
                                                style={{ width: `33%` }}
                                              ></div>
                                            </div>
                                          </div>
                                        )}
                                      {parseInt(
                                        e?.expectedsalary
                                          ?.split(" ")[1]
                                          ?.replaceAll(",", "")
                                      ) >= minSalary &&
                                        parseInt(
                                          e?.expectedsalary
                                            ?.split(" ")[1]
                                            ?.replaceAll(",", "")
                                        ) <= maxSalary && (
                                          <div className="text-[#40B2B7]">
                                            <p className="text-[0.7rem]">
                                              Within Range
                                            </p>
                                            <div className="bg-[#E9EBFA] h-[0.5rem] relative my-1 rounded-lg w-[3.9rem] mx-auto">
                                              <div
                                                className={`absolute bg-[#40B2B7] h-[0.5rem] rounded-lg`}
                                                style={{ width: `50%` }}
                                              ></div>
                                            </div>
                                          </div>
                                        )}
                                      {parseInt(
                                        e?.expectedsalary
                                          ?.split(" ")[1]
                                          ?.replaceAll(",", "")
                                      ) > maxSalary && (
                                          <div className="text-[#E95060]">
                                            <p className="text-[0.7rem]">
                                              Above Range
                                            </p>
                                            <div className="bg-[#E9EBFA] h-[0.5rem] relative my-1 rounded-lg w-[3.9rem] mx-auto">
                                              <div
                                                className={`absolute bg-[#E95060] h-[0.5rem] rounded-lg`}
                                                style={{ width: `66%` }}
                                              ></div>
                                            </div>
                                          </div>
                                        )}
                                      {!e.expectedsalary && <p>-</p>}
                                    </button>
                                    {parseInt(
                                      e?.expectedsalary
                                        ?.split(" ")[1]
                                        ?.replaceAll(",", "")
                                    ) < minSalary && (
                                        <div
                                          textv
                                          className="absolute transition-all left-11 top-16   px-[10px] py-[7px] text-left shadow-md z-20 border-2 whitespace-nowrap border-[#8F94A1]  scale-0 rounded-lg bg-white  text-[9px]  group-hover:scale-100"
                                        >
                                          <p className="mb-1 gap-[4px] flex">
                                            <b>Current Salary: </b>
                                            <span>{e.currentsalary}</span>
                                          </p>
                                          <p className="flex gap-[4px]">
                                            <b>Expected Salary: </b>
                                            <span>{e.expectedsalary}</span>
                                          </p>
                                        </div>
                                      )}
                                    {parseInt(
                                      e?.expectedsalary
                                        ?.split(" ")[1]
                                        ?.replaceAll(",", "")
                                    ) > minSalary &&
                                      parseInt(
                                        e?.expectedsalary
                                          ?.split(" ")[1]
                                          ?.replaceAll(",", "")
                                      ) < maxSalary && (
                                        <div
                                          textv
                                          className="absolute transition-all left-11 top-16   px-[10px] py-[7px] text-left shadow-md z-20 border-2 whitespace-nowrap border-[#40B2B7]  scale-0 rounded-lg bg-white  text-[9px]  group-hover:scale-100"
                                        >
                                          <p className="mb-1 gap-[4px] flex">
                                            <b>Current Salary: </b>
                                            <span>{e.currentsalary}</span>
                                          </p>
                                          <p className="flex gap-[4px]">
                                            <b>Expected Salary: </b>
                                            <span>{e.expectedsalary}</span>
                                          </p>
                                        </div>
                                      )}
                                    {parseInt(
                                      e?.expectedsalary
                                        ?.split(" ")[1]
                                        ?.replaceAll(",", "")
                                    ) > maxSalary && (
                                        <div
                                          textv
                                          className="absolute transition-all left-11 top-16   px-[10px] py-[7px] text-left shadow-md z-20 border-2 whitespace-nowrap border-[#E95060]  scale-0 rounded-lg bg-white  text-[9px]  group-hover:scale-100"
                                        >
                                          <p className="mb-1 gap-[4px] flex">
                                            <b>Current Salary: </b>
                                            <span>{e.currentsalary}</span>
                                          </p>
                                          <p className="flex gap-[4px]">
                                            <b>Expected Salary: </b>
                                            <span>{e.expectedsalary}</span>
                                          </p>
                                        </div>
                                      )}
                                  </div>
                                </Td>
                                <Td className="border-y px-4 py-[23px] text-left w-[170px] text-[12px]">
                                  <Select
                                    value={popUpValue}
                                    onChange={(option) => {
                                      setSelectedModalIsOpen(option.value);
                                      setStatus(e.status);
                                      setActiveUuid(e.uuid);
                                    }}
                                    options={onRejectOptions}
                                    placeholder="Select Action"
                                  ></Select>
                                </Td>
                              </Tr>
                            );
                          })}
                        </Tbody>
                      </Table>
                    </div>
                    <nav className="bg-white mt-4  flex items-center justify-between">
                      <div className="hidden sm:block">
                        <div className="flex items-center text-[14px] font-normal z-10 gap-2">
                          Show
                          <Select
                            placeholder={itemsPerPage}
                            options={perPageOptions}
                            className="z-20 text-[14px] page-select  "
                            onChange={(selectedOption) => {
                              setItemsPerPage(selectedOption.value);
                            }}
                            menuPlacement="top"
                          />
                          entries
                        </div>
                      </div>
                      <div className="flex-1 flex justify-between sm:justify-end ">
                        <button
                          onClick={() =>
                            setCurrentInterviewedPage(
                              currentInterviewedPage - 1
                            )
                          }
                          disabled={currentInterviewedPage === 1}
                          className={`relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-l-md text-gray-700 bg-white hover:text-gray-500 ${currentInterviewedPage === 1
                            ? "opacity-50"
                            : "hover:bg-gray-50"
                            }`}
                        >
                          Previous
                        </button>
                        <div className="flex ">
                          {getInterviewedPageRange().map((page) => (
                            <button
                              key={page}
                              onClick={() => setCurrentInterviewedPage(page)}
                              className={`relative inline-flex items-center px-4 py-2 border-y border-r border-gray-300 text-sm font-medium  text-gray-700   cursor-pointer ${currentInterviewedPage === page
                                ? "bg-light-blue text-white"
                                : ""
                                }`}
                            >
                              {page}
                            </button>
                          ))}
                        </div>
                        <button
                          onClick={() =>
                            setCurrentInterviewedPage(
                              currentInterviewedPage + 1
                            )
                          }
                          disabled={
                            currentInterviewedPage === totalInterviewedPages
                          }
                          className={`relative inline-flex items-center px-4 py-2 border-y border-r border-gray-300 text-sm font-medium rounded-r-md text-gray-700 bg-white hover:text-gray-500 ${currentInterviewedPage === totalInterviewedPages
                            ? "opacity-50"
                            : "hover:bg-gray-50"
                            }`}
                        >
                          Next
                        </button>
                      </div>
                    </nav>
                  </>
                )}
              </div>
            </>
          ) : (
            ""
          )}
        </div>
        <footer className="text-center text-[14px] font-normal   p-[20px] pb-0">
          Copyright © 2023 Novelio Technologies Pvt. Ltd.
        </footer>
      </div>
      {multipleSelectModal && (
        <>
          <div className="bg-white h-[90%] fixed rounded-xl shadow-2xl z-50 w-[90%] left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 flex flex-col">
            <div className="card-header flex justify-between pt-6 px-6 pb-4 border-b">
              <div className="text-2xl font-medium">Interview Feedback</div>
              <button
                className=""
                onClick={() => {
                  setMultipleSelectModal("");
                  setStar(0);
                }}
              >
                <IoMdClose className="w-6 h-6" />
              </button>
            </div>
            <div className="flex-1 overflow-auto p-6 border-t">
              <Table className="w-full">
                <Thead className="text-center text-sm">
                  <Tr>
                    <Th className="border px-4 py-[23px] py-[20px]">
                      Candidate
                    </Th>
                    <Th className="border px-4 py-[23px] ">
                      Interviewer <span className="text-red-400">*</span>
                    </Th>
                    <Th className="border px-4 py-[23px] ">
                      Interview Date <span className="text-red-400">*</span>
                    </Th>
                    <Th className="border px-4 py-[23px] ">
                      Rating <span className="text-red-400">*</span>
                    </Th>
                    {multipleSelectModal == "reject" && (
                      <Th className="border px-4 py-[23px] ">
                        Rejection Reason <span className="text-red-400">*</span>
                      </Th>
                    )}
                    <Th className="border px-4 py-[23px] ">
                      Detailed Feedback
                    </Th>
                  </Tr>
                </Thead>
                <Tbody className="text-center">
                  {paginatedAll
                    .filter((candidate) =>
                      selectedRows.includes(candidate.uuid)
                    )
                    .map((e, i) => (
                      <Tr key={e.uuid}>
                        <Td className="border px-4 py-[23px] font-semibold">
                          {e.name}
                        </Td>
                        <Td className="border px-4 py-[23px] ">
                          {e?.interviewer}
                        </Td>
                        <Td className="border px-4 py-[23px] ">
                          {formatDate(e.interviewdate)}
                        </Td>
                        <Td className="border-y  px-4 py-[23px]  flex justify-center items-center">
                          <ReactStars
                            count={5}
                            className="-mt-3 flex gap-1"
                            value={star}
                            onChange={(newRating) => {
                              setOldratting([...oldratting, newRating]);
                              setStar(newRating);
                            }}
                            isHalf={false}
                            half={false}
                            edit={true}
                            size={40}
                            color2={"#FFA500"}
                            color1={"gray"}
                          />
                        </Td>
                        {multipleSelectModal == "reject" && (
                          <Td className="border px-4 py-[23px] ">
                            <Select
                              className=""
                              options={reasonOptions}
                              placeholder="Select a reason"
                            ></Select>
                          </Td>
                        )}
                        <Td className="border">
                          <textarea
                            className="w-full h-full px-4 py-[23px] "
                            placeholder="Describe your feedback here.."
                            onChange={(e) => {
                              setFeedback(e.target.value);
                            }}
                          />
                        </Td>
                      </Tr>
                    ))}
                </Tbody>
              </Table>
            </div>
            <div className="border-t p-6">
              <div className="flex justify-end">
                <button
                  className="bg-[#148EFF] hover:bg-blue-500 text-white font-bold py-2 px-4 rounded"
                  onClick={() => {
                    setPopUpValue(modalIsOpen);
                    setoldFeedback([...oldFeedback, feedback]);
                    if (modalIsOpen === "reject") {
                      toast.success("Candidate has been successfully rejected", { icon: <ToastIcon /> });
                    } else if (modalIsOpen === "hold") {
                      toast.success(
                        "Candidate has been successfully put on-hold"
                        , { icon: <ToastIcon /> });
                    } else if (modalIsOpen === "select") {
                      toast.success("Candidate has been successfully selected", { icon: <ToastIcon /> });
                    } else if (modalIsOpen === "change rounds") {
                      toast.success(
                        `Candidate has been successfully moved to Round ${subtab + 1
                        } of the interview`
                        , { icon: <ToastIcon /> });
                    }
                  }}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </>
      )}
      {modalIsOpen && (
        <>
          {modalIsOpen == "select" && subtab == 0 ? (
            ""
          ) : (
            <div className="bg-white  fixed rounded-xl shadow-2xl z-50 w-1/2 left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
              <div className="card-header flex justify-between pt-6 px-6 pb-4">
                <div className="text-2xl font-medium">Interview Feedback</div>
                <button
                  className=""
                  onClick={() => {
                    setmodalIsOpen("");
                    setStar(0);
                  }}
                >
                  <IoMdClose className="w-6 h-6" />
                </button>
              </div>
              <div className="border w-full"></div>
              <div className="card-body p-6 flex flex-col gap-2">
                <div className="w-full flex gap-4 mb-3">
                  <div className="w-1/2">
                    <div className="text-base  mb-2 font-semibold">
                      Interviewer{" "}
                      <span className="text-red-400 justify start">*</span>
                    </div>
                    <div>
                      <Select
                        className=""
                        options={[...recruiters, ...hiringManagers]}
                        placeholder="Select Recruiter,Hiring Manager"
                        onChange={(selectedOption) => {
                          setSelectedHm(selectedOption);
                        }}
                      ></Select>
                    </div>
                  </div>
                  <div className="w-1/2">
                    <div className="text-base  mb-2 font-semibold">
                      Interview Date{" "}
                      <span className="text-red-400 justify start">*</span>
                    </div>
                    <div className=" w-full ">
                      <div className="flex items-center justify-center border rounded  border-gray-300">
                        {" "}
                        <span className="bg-[#D2D4DA] flex items-center w-fit h-9 px-2 ">
                          <MdOutlineDateRange className="text-[#8F94A1] w-5 h-5" />
                        </span>{" "}
                        <input
                          value={interviewDate}
                          className="w-full rounded h-9 px-4"
                          placeholder="Select Date"
                          onChange={(e) => {
                            setInterviewDate(e.target.value);
                          }}
                          type="date"
                        ></input>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex flex-col  mb-3">
                  <div className="text-base  font-semibold mb-2">
                    Outcome{" "}
                    <span className="text-red-400 justify start">*</span>
                  </div>
                  <div className="flex gap-1 ">
                    <button
                      className={`${modalIsOpen == "change rounds"
                        ? "bg-blue-100 text-blue-800 text-sm font-medium me-2 px-2.5 py-0.5 rounded  dark:text-blue-400 border border-blue-400"
                        : "bg-gray-100 text-gray-800 text-sm font-medium me-2 px-2.5 py-0.5 rounded  dark:text-gray-400 border border-gray-500"
                        } `}
                      onClick={() => {
                        setmodalIsOpen("change rounds");
                      }}
                    >
                      {`Move to round ${subtab + 1}`}
                    </button>
                    <button
                      className={`${modalIsOpen == "select"
                        ? "bg-green-100 text-green-800 text-sm font-medium me-2 px-2.5 py-0.5 rounded  dark:text-green-400 border border-green-400"
                        : "bg-gray-100 text-gray-800 text-sm font-medium me-2 px-2.5 py-0.5 rounded  dark:text-gray-400 border border-gray-500"
                        } `}
                      onClick={() => {
                        setmodalIsOpen("select");
                      }}
                    >
                      Select
                    </button>
                    <button
                      className={`${modalIsOpen == "reject"
                        ? "bg-red-100 text-red-800 text-sm font-medium me-2 px-2.5 py-0.5 rounded  dark:text-red-400 border border-red-400"
                        : "bg-gray-100 text-gray-800 text-sm font-medium me-2 px-2.5 py-0.5 rounded  dark:text-gray-400 border border-gray-500"
                        } `}
                      onClick={() => {
                        setmodalIsOpen("reject");
                      }}
                    >
                      Reject
                    </button>
                    <button
                      className={`${modalIsOpen == "hold"
                        ? "bg-yellow-100 text-yellow-800 text-sm font-medium me-2 px-2.5 py-0.5 rounded dark:text-yellow-300 border border-yellow-300"
                        : "bg-gray-100 text-gray-800 text-sm font-medium me-2 px-2.5 py-0.5 rounded  dark:text-gray-400 border border-gray-500"
                        } `}
                      onClick={() => {
                        setmodalIsOpen("hold");
                      }}
                    >
                      On-hold
                    </button>
                  </div>
                </div>
                {modalIsOpen == "change rounds" ? (
                  <div className="flex flex-col gap-[0.5rem]  mb-3">
                    <div className="text-base font-semibold">
                      Rating{" "}
                      <span className="text-red-400 justify start">*</span>
                    </div>
                    <div>
                      <ReactStars
                        count={5}
                        className="-mt-3 flex gap-1 "
                        value={star}
                        onChange={(e) => {
                          setOldratting([...oldratting, e]);
                          setStar(e);
                        }}
                        isHalf={false}
                        half={false}
                        edit={true}
                        size={30}
                        color2={"#FFA500"}
                        color1={"gray"}
                      // Use hollow star icon
                      ></ReactStars>
                    </div>
                  </div>
                ) : (
                  ""
                )}

                {modalIsOpen == "reject" && (
                  <div className="flex flex-col gap-1">
                    <div className="text-base font-semibold">
                      Why are you rejecting the candidate?{" "}
                      <span className="text-red-400 justify start">*</span>
                    </div>
                    <div className="w-full">
                      <div>
                        <Select
                          className=""
                          options={reasonOptions}
                          placeholder="Select a reason"
                        ></Select>
                      </div>
                    </div>
                  </div>
                )}
                {modalIsOpen == "hold" && (
                  <div className="flex flex-col gap-1">
                    <div className="text-base font-semibold">
                      Specify the reason for candidate being put on hold{" "}
                      <span className="text-red-400 justify start">*</span>
                    </div>
                    <div className="w-full">
                      <div>
                        <Select
                          className=""
                          options={reasonOptions}
                          placeholder="Select a reason"
                        ></Select>
                      </div>
                    </div>
                  </div>
                )}
                <div className="flex flex-col  mb-3">
                  <div className="text-base font-semibold mb-2">
                    Detailed Feedback
                  </div>
                  <div>
                    <textarea
                      className="w-full p-3 border border-gray-300 rounded-md"
                      placeholder="Describe your feedback here.."
                      rows={4}
                      onChange={(e) => {
                        setFeedback(e.target.value);
                      }}
                    ></textarea>
                  </div>
                </div>
                {modalIsOpen == "change rounds" && (
                  <div className="flex flex-col gap-1">
                    <div className="text-base font-semibold mb-2">
                      Create Interview for next round
                    </div>
                    <div className="text-base font-semibold">
                      Assign Interviewer
                    </div>
                    <div className="w-full">
                      <div>
                        <Select
                          className=""
                          menuPlacement="top"
                          options={[...recruiters, ...hiringManagers]}
                          placeholder="Select Recruiter,Hiring Manager"
                          onChange={(selectedOption) => {
                            setSelectedHm(selectedOption);
                          }}
                        ></Select>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div className="border w-full"></div>
              <div className=" card-footer pb-3 pl-6 pr-6 pt-3 relative">
                <div className="flex justify-end">
                  <button
                    className="bg-[#148EFF] hover:bg-blue-500 text-white font-bold py-2 px-4 rounded"
                    onClick={() => {
                      setPopUpValue(modalIsOpen);
                      setoldFeedback([...oldFeedback, feedback]);
                      if (modalIsOpen == "reject") {
                        toast.success(
                          "Candidate has been successfully rejected"
                          , { icon: <ToastIcon /> });
                      } else if (modalIsOpen == "hold") {
                        toast.success(
                          "Candidate has been successfully put on-hold"
                          , { icon: <ToastIcon /> });
                      } else if (modalIsOpen == "select") {
                        toast.success(
                          "Candidate has been successfully selected"
                          , { icon: <ToastIcon /> });
                      } else if (modalIsOpen == "change rounds") {
                        handleRoundinfo(activeUuid, subtab, subtab + 1);
                        toast.success(
                          `Candidate has been successfully moved to Round ${subtab + 1
                          } of the interview`
                          , { icon: <ToastIcon /> });
                      }
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          )}
        </>
      )}
      {modalIsOpen == "select" && subtab == 0 && (
        <>
          <div className="bg-white  fixed rounded-xl shadow-2xl z-50 w-1/2 left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
            <div className="card-header flex justify-between pt-6 px-6 pb-4">
              <div className="text-2xl font-medium">Interview Feedback</div>
              <button
                className=""
                onClick={() => {
                  setmodalIsOpen("");
                  setStar(0);
                }}
              >
                <IoMdClose className="w-6 h-6" />
              </button>
            </div>
            <div className="border w-full"></div>
            <div className="card-body p-6 flex flex-col gap-2">
              <div className="w-full flex gap-4 mb-3"></div>

              <div className="p-3 bg-[#FFD9B2] flex items-center gap-2 rounded-md mb-4 cursor-pointer">
                <IoAlertCircleOutline className="w-8 h-8 text-[#FE9933] " />{" "}
                <div className="text-base">
                  You have chosen the candidate without the interview
                </div>
              </div>

              <div className="flex flex-col  mb-3">
                <div className="text-base font-semibold mb-2">
                  Specify the reason for selection{" "}
                  <span className="text-red-400 justify start">*</span>
                </div>

                <div>
                  <textarea
                    className="w-full p-3 border border-gray-300 rounded-md"
                    placeholder="Describe your feedback here.."
                    rows={4}
                    onChange={(e) => {
                      setFeedback(e.target.value);
                    }}
                  ></textarea>
                </div>
              </div>
            </div>
            <div className="border w-full"></div>
            <div className=" card-footer pb-3 pl-6 pr-6 pt-3 relative">
              <div className="flex justify-end">
                <button
                  className="bg-[#148EFF] hover:bg-blue-500 text-white font-bold py-2 px-4 rounded"
                  onClick={() => {
                    setPopUpValue(modalIsOpen);
                    setoldFeedback([...oldFeedback, feedback]);

                    if (modalIsOpen == "select") {
                      toast.success("Candidate has been successfully selected", { icon: <ToastIcon /> });
                    }
                  }}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </>
      )}

      {selectedModalIsOpen && (
        <>
          <div className="bg-white  fixed rounded-xl shadow-2xl z-50 w-1/2 left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
            <div className="card-header flex justify-between pt-6 px-6 pb-4">
              <div className="text-2xl font-medium">Interview Feedback</div>
              <button
                className=""
                onClick={() => {
                  setSelectedModalIsOpen("");
                  setStar(0);
                }}
              >
                <IoMdClose className="w-6 h-6" />
              </button>
            </div>
            <div className="border w-full"></div>
            <div className="card-body p-6 flex flex-col gap-4">
              <div className="flex flex-col gap-2">
                <div className="text-base font-semibold ">
                  Outcome <span className="text-red-400 justify start">*</span>
                </div>
                <div className="flex gap-1">
                  <button
                    className={`${selectedModalIsOpen == "offer"
                      ? "bg-blue-100 text-blue-800 text-sm font-medium me-2 px-2.5 py-0.5 rounded  dark:text-blue-400 border border-blue-400"
                      : "bg-gray-100 text-gray-800 text-sm font-medium me-2 px-2.5 py-0.5 rounded  dark:text-gray-400 border border-gray-500"
                      } `}
                    onClick={() => {
                      setSelectedModalIsOpen("offer");
                    }}
                  >
                    Move to offer
                  </button>
                  <button
                    className={`${selectedModalIsOpen == "reject"
                      ? "bg-red-100 text-red-800 text-sm font-medium me-2 px-2.5 py-0.5 rounded  dark:text-red-400 border border-red-400"
                      : "bg-gray-100 text-gray-800 text-sm font-medium me-2 px-2.5 py-0.5 rounded  dark:text-gray-400 border border-gray-500"
                      } `}
                    onClick={() => {
                      setSelectedModalIsOpen("reject");
                    }}
                  >
                    Reject
                  </button>
                  <button
                    className={`${selectedModalIsOpen == "hold"
                      ? "bg-yellow-100 text-yellow-800 text-sm font-medium me-2 px-2.5 py-0.5 rounded dark:text-yellow-300 border border-yellow-300"
                      : "bg-gray-100 text-gray-800 text-sm font-medium me-2 px-2.5 py-0.5 rounded  dark:text-gray-400 border border-gray-500"
                      } `}
                    onClick={() => {
                      setSelectedModalIsOpen("hold");
                    }}
                  >
                    On-hold
                  </button>
                </div>
              </div>
              {selectedModalIsOpen == "reject" && (
                <div className="flex flex-col gap-1">
                  <div className="text-base font-semibold">
                    Why are you rejecting the candidate?{" "}
                    <span className="text-red-400 justify start">*</span>
                  </div>
                  <div className="w-full">
                    <div>
                      <Select
                        className=""
                        options={reasonOptions}
                        placeholder="Select a reason"
                      ></Select>
                    </div>
                  </div>
                </div>
              )}
              <div className="flex flex-col gap-2">
                <div className="text-base font-semibold">Detailed Feedback</div>
                <div>
                  <textarea
                    className="w-full p-3 border border-gray-300 rounded-md"
                    placeholder="Describe your feedback here.."
                    rows={4}
                  ></textarea>
                </div>
              </div>
            </div>
            <div className="border w-full"></div>
            <div className=" card-footer pb-3 pl-6 pr-6 pt-3 relative">
              <div className="flex justify-end">
                <button
                  className="bg-[#148EFF] hover:bg-blue-500 text-white font-bold py-2 px-4 rounded"
                  onClick={() => {
                    setPopUpValue(selectedModalIsOpen);
                    setoldFeedback([...oldFeedback, feedback]);
                    if (selectedModalIsOpen == "reject") {
                      toast.success("Candidate has been successfully rejected", { icon: <ToastIcon /> });
                    } else if (selectedModalIsOpen == "hold") {
                      toast.success(
                        "Candidate has been successfully put on-hold"
                        , { icon: <ToastIcon /> });
                    } else if (selectedModalIsOpen == "offer") {
                      toast.success(
                        "Candidate has been successfully moved to offer stage"
                        , { icon: <ToastIcon /> });
                    }
                  }}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </>
      )}
      <ToastContainer
        autoClose={5000}
        hideProgressBar={true}
        toastClassName={(context) =>
          " relative flex p-1  min-h-10 rounded-[8px] bg-white w-fit flex-row justify-between border-2 border-[#0DCD94] overflow-hidden cursor-pointer"
        }
        bodyClassName={() =>
          "text-[14px] gap-3 flex text-[#161A21] font-medium  p-3  pr-1"
        }
      />
    </>
  );
};

export default TempCandidates;
